'use client'
import {
  ActionCard_default
} from "./chunk-7SNQ645S.mjs";
import {
  MatchItemLoader_default
} from "./chunk-VIN62BPX.mjs";
import {
  ProductItemSkeleton
} from "./chunk-GQJK47PM.mjs";
import {
  BookingType_default,
  Deal_default,
  Item_default,
  Zone_default
} from "./chunk-X26Q276J.mjs";
import {
  Button_default
} from "./chunk-KPHPJUNU.mjs";
import {
  NotifyButton_default
} from "./chunk-WZIEBXDX.mjs";
import {
  CarouselWithLink_default
} from "./chunk-LVDZESI2.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulButton_default
} from "./chunk-K3ITZBKW.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";
import {
  createSectionItemHref,
  parseCardItem,
  parseSectionItem,
  resolveContentfulEventType
} from "./chunk-DJNQ4XY4.mjs";
import {
  resolveProductEventType
} from "./chunk-NY6K524K.mjs";
import {
  groupEventsByDay
} from "./chunk-HNKZBJGK.mjs";
import {
  useGetInfiniteProductsList,
  useGetProductsList
} from "./chunk-EZ7QK247.mjs";
import {
  useGetExplore
} from "./chunk-HATK644S.mjs";
import {
  useGetCity
} from "./chunk-BPGTMBWX.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/product/sections/ActionCardCarousel.tsx
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
var ActionCardCarousel = ({ section, className }) => {
  const events = section.contentCollection.items;
  if (!(events == null ? void 0 : events.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    DecoratedSection_default,
    {
      section,
      className: twMerge("container", className),
      "data-testid": `section_events_grid_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx(CarouselWithLink_default, { section, linkClassName: "relative shrink-0 basis-64 md:basis-72", children: events.map((event, i) => /* @__PURE__ */ jsx(
        ActionCard_default,
        {
          item: event,
          section,
          className: "shrink-0 basis-64 md:basis-72 ltr:mr-4 rtl:ml-4"
        },
        i
      )) })
    }
  );
};
var ActionCardCarousel_default = ActionCardCarousel;

// src/components/product/sections/ComingSoonSection.tsx
import { Fragment } from "react";
import { Carousel, Typography } from "@wbk/ui";
import { useRouter } from "@wbk/config";
import { Fragment as Fragment2, jsx as jsx2, jsxs } from "react/jsx-runtime";
var query = {
  limit: 10,
  order: ["order_ASC", "sys_firstPublishedAt_DESC"]
};
var ComingSoonSection = ({ section }) => {
  const { locale } = useRouter();
  const { data: exploreData, isLoading } = useGetExplore(__spreadProps(__spreadValues({}, query), {
    lang: locale,
    entities: ["product"],
    where: {
      action: { type: "coming_soon" }
    }
  }));
  const items = (exploreData == null ? void 0 : exploreData.data) || [];
  if (!(items == null ? void 0 : items.length) && !isLoading) {
    return null;
  }
  return /* @__PURE__ */ jsx2(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_coming_soon_${section.id}`,
      children: /* @__PURE__ */ jsx2(
        Carousel,
        {
          className: "p-1",
          options: { dragFree: true },
          title: /* @__PURE__ */ jsxs(Fragment2, { children: [
            section.title && /* @__PURE__ */ jsx2(Typography, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx2(Typography, { color: "text-secondary", className: "mt-1", children: section.subtitle })
          ] }),
          arrows: "top",
          children: isLoading ? [...new Array(10)].map((_, i) => /* @__PURE__ */ jsx2(
            "div",
            {
              className: "xs:basis-1/2 relative shrink-0 basis-[85%] md:basis-[28%] lg:basis-[22%] xl:basis-[18%] ltr:mr-4 rtl:ml-4",
              children: /* @__PURE__ */ jsx2(ProductItemSkeleton, {})
            },
            i
          )) : items.map((event, i) => /* @__PURE__ */ jsx2(Fragment, { children: /* @__PURE__ */ jsx2("div", { className: "xs:basis-1/2 relative shrink-0 basis-[85%] md:basis-[28%] lg:basis-[22%] xl:basis-[18%] ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx2(
            Item_default,
            {
              item: event,
              cardType: section.itemRenderType,
              section: { id: section.id },
              index: i
            }
          ) }) }, i))
        }
      )
    }
  );
};
var ComingSoonSection_default = ComingSoonSection;

// src/components/product/sections/FullScreenCarousel.tsx
import { Button, Carousel as Carousel2, Typography as Typography2 } from "@wbk/ui";
import { CurrencyPriceLabel } from "@wbk/currency";
import { useAnalytics } from "@wbk/analytics";
import { Link, useRouter as useRouter2, useTranslation } from "@wbk/config";
import { Fragment as Fragment3, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var FullScreenCarousel = ({ section }) => {
  const items = section.contentCollection.items;
  const { locale } = useRouter2();
  const { t } = useTranslation("contentful_common");
  const { trackEvent } = useAnalytics();
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx3(DecoratedSection_default, { section, "data-testid": `section_fullscreen_carousel_${section.id}`, children: /* @__PURE__ */ jsx3(
    Carousel2,
    {
      className: "pb-20",
      options: {
        align: "center",
        loop: true,
        slidesToScroll: 1,
        active: items.length > 1
      },
      autoplay: {
        delay: 3e3,
        stopOnMouseEnter: true
      },
      arrows: "top",
      arrowsClassName: "container",
      title: /* @__PURE__ */ jsxs2(Fragment3, { children: [
        section.title && /* @__PURE__ */ jsx3(Typography2, { as: "h2", variant: "heading-L", children: section.title }),
        section.subtitle && /* @__PURE__ */ jsx3(Typography2, { color: "text-secondary", className: "mt-1", children: section.subtitle })
      ] }),
      dots: true,
      children: items.map((item, idx) => {
        var _a, _b, _c, _d, _e, _f;
        const parsedItem = parseSectionItem({ item, locale });
        if (!parsedItem) return null;
        const dealPrice = "deal" in item ? (_a = item.deal) == null ? void 0 : _a.price : 0;
        const discountedPrice = "discountedPrice" in item ? item.discountedPrice : 0;
        const price = dealPrice || discountedPrice || parsedItem.startingPrice;
        const hasContent = parsedItem.title || parsedItem.subtitle || parsedItem.startingPrice;
        const subContent = typeof parsedItem.startingPrice === "number" || (parsedItem == null ? void 0 : parsedItem.subtitle) || (parsedItem == null ? void 0 : parsedItem.eventType);
        const external = (_b = parsedItem.href) == null ? void 0 : _b.startsWith("http");
        const isLcp = idx === 0;
        const desktop = typeof window !== "undefined" && window.matchMedia("(min-width: 640px)").matches;
        const lcpProps = { loading: "eager", fetchPriority: "high" };
        return /* @__PURE__ */ jsx3(
          "div",
          {
            className: "group mx-auto flex h-full w-full shrink-0 items-center justify-center sm:container",
            children: /* @__PURE__ */ jsx3(
              Button,
              {
                as: parsedItem.href ? Link : "div",
                theme: "transparent",
                shape: "text",
                href: parsedItem.href,
                target: external ? "_blank" : void 0,
                className: "border-paper relative h-full basis-full flex-col justify-between rounded-none p-0 sm:rounded-lg sm:border",
                onClick: () => {
                  var _a2;
                  trackEvent({
                    event: "clicked_on_section_item",
                    data: {
                      type: parsedItem.__typename,
                      item_id: (_a2 = parsedItem.sys) == null ? void 0 : _a2.id,
                      slug: parsedItem.href,
                      label: parsedItem.title,
                      section: section.id,
                      position: idx
                    }
                  });
                },
                children: /* @__PURE__ */ jsxs2("div", { className: "aspect-1 h-full w-full sm:aspect-[3/1]", children: [
                  /* @__PURE__ */ jsx3(
                    ContentfulMedia_default,
                    __spreadValues({
                      media: parsedItem.image31,
                      poster: (_c = parsedItem.background) == null ? void 0 : _c.url,
                      className: "hidden h-full w-full overflow-hidden object-cover object-center sm:block",
                      ratio: "3x1",
                      placeholder: true,
                      controls: true
                    }, isLcp && desktop ? lcpProps : {})
                  ),
                  /* @__PURE__ */ jsx3(
                    ContentfulMedia_default,
                    __spreadValues({
                      media: parsedItem.image11,
                      poster: (_d = parsedItem.background) == null ? void 0 : _d.url,
                      className: "h-full w-full overflow-hidden object-cover object-center sm:hidden",
                      width: 800,
                      height: 800,
                      fit: "thumb",
                      ratio: "1x1",
                      placeholder: true,
                      controls: true
                    }, isLcp && !desktop ? lcpProps : {})
                  ),
                  hasContent && /* @__PURE__ */ jsxs2(Fragment3, { children: [
                    /* @__PURE__ */ jsx3("div", { className: "absolute bottom-0 left-0 right-0 z-10 flex items-center justify-between p-4 text-white", children: /* @__PURE__ */ jsxs2("div", { className: "gap-y-M md:gap-y-L flex flex-col", children: [
                      /* @__PURE__ */ jsxs2("div", { className: "gap-y-S flex flex-col items-start", children: [
                        /* @__PURE__ */ jsx3(Typography2, { as: "h2", variant: "heading-XXL", className: "text-start", children: parsedItem.title }),
                        (parsedItem == null ? void 0 : parsedItem.subtitle) && /* @__PURE__ */ jsx3(Typography2, { children: parsedItem == null ? void 0 : parsedItem.subtitle }),
                        ((_e = parsedItem == null ? void 0 : parsedItem.location) == null ? void 0 : _e.address) && /* @__PURE__ */ jsx3(Typography2, { variant: "label-L", className: "text-start", children: (_f = parsedItem == null ? void 0 : parsedItem.location) == null ? void 0 : _f.address }),
                        parsedItem.deal && /* @__PURE__ */ jsx3(
                          Deal_default,
                          {
                            item: parsedItem,
                            className: "relative m-0 inline-flex",
                            showLabel: true
                          }
                        )
                      ] }),
                      subContent && /* @__PURE__ */ jsxs2("div", { className: "gap-y-XXS flex flex-col", children: [
                        typeof parsedItem.startingPrice === "number" ? parsedItem.startingPrice > 0 ? /* @__PURE__ */ jsxs2("div", { className: "gap-x-XXS flex flex-row items-center justify-start", children: [
                          /* @__PURE__ */ jsx3(Typography2, { variant: "body-L", color: "text-secondary", strong: true, children: t("contentful_common:starts_from") }),
                          /* @__PURE__ */ jsx3(
                            CurrencyPriceLabel,
                            {
                              originalPrice: parsedItem.startingPrice,
                              discountPrice: price,
                              currency: parsedItem.currencyCode
                            }
                          )
                        ] }) : /* @__PURE__ */ jsx3(
                          Typography2,
                          {
                            variant: "body-L",
                            className: "text-tertiary w-full text-start font-bold",
                            children: t("contentful_common:free")
                          }
                        ) : null,
                        /* @__PURE__ */ jsx3(
                          BookingType_default,
                          {
                            className: "py-0.5",
                            type: parsedItem == null ? void 0 : parsedItem.eventType,
                            mini: true
                          }
                        )
                      ] })
                    ] }) }),
                    /* @__PURE__ */ jsx3("div", { className: "absolute bottom-0 left-0 right-0 h-[80%] bg-gradient-to-t from-black/90 from-[10%] via-black/20 via-[70%] to-transparent to-[100%]" })
                  ] })
                ] })
              }
            )
          },
          parsedItem.id
        );
      })
    }
  ) });
};
var FullScreenCarousel_default = FullScreenCarousel;

// src/components/product/sections/FullScreenGeoCarousel.tsx
import { useMemo } from "react";
import { Button as Button2, Carousel as Carousel3, ImageWithPlaceholder, Typography as Typography3 } from "@wbk/ui";
import { CurrencyPriceLabel as CurrencyPriceLabel2 } from "@wbk/currency";
import { useAnalytics as useAnalytics2 } from "@wbk/analytics";
import { Link as Link2, useRouter as useRouter3, useTranslation as useTranslation2 } from "@wbk/config";
import { Fragment as Fragment4, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var FullScreenGeoCarousel = ({ section }) => {
  const { locale, search } = useRouter3();
  const { t } = useTranslation2("contentful_common");
  const destination = search.get("destination") || "";
  const { trackEvent } = useAnalytics2();
  const query3 = useMemo(() => {
    const filters3 = [];
    if (section.tagsCollection.items.length) {
      filters3.push({ tags: { slug_in: section.tagsCollection.items.map((tag) => tag.slug) } });
    }
    if (destination) {
      filters3.push({ location: { cityCode: destination } });
    }
    return filters3.length > 0 ? { AND: filters3 } : void 0;
  }, [destination, section.tagsCollection.items]);
  const { data, isLoading } = useGetProductsList({
    where: query3,
    lang: locale
  });
  const items = (data == null ? void 0 : data.items) || [];
  if (!(items == null ? void 0 : items.length) && !isLoading) {
    return null;
  }
  return /* @__PURE__ */ jsx4(
    DecoratedSection_default,
    {
      section,
      "data-testid": `section_fullscreen_geo_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx4(
        Carousel3,
        {
          className: "pb-20",
          options: {
            align: "center",
            loop: true,
            slidesToScroll: 1,
            active: items.length > 1
          },
          autoplay: {
            delay: 3e3,
            stopOnMouseEnter: true
          },
          arrows: "top",
          arrowsClassName: "container",
          title: /* @__PURE__ */ jsxs3(Fragment4, { children: [
            section.title && /* @__PURE__ */ jsx4(Typography3, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx4(Typography3, { color: "text-secondary", className: "mt-1", children: section.subtitle })
          ] }),
          dots: true,
          children: isLoading ? [...new Array(3)].map((_, i) => /* @__PURE__ */ jsx4("div", { className: "relative shrink-0 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx4(
            ImageWithPlaceholder,
            {
              ratio: "3x1",
              className: "bg-paper-level-2 aspect-[3/1] w-full animate-pulse rounded-md",
              alt: ""
            }
          ) }, i)) : items.map((item, index) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
            const urlType = resolveContentfulEventType(item);
            const href = `/${locale}/${urlType}/${item.slug}`;
            const external = href == null ? void 0 : href.startsWith("http");
            const isLcp = index === 0;
            const desktop = typeof window !== "undefined" && window.matchMedia("(min-width: 640px)").matches;
            const lcpProps = { loading: "eager", fetchPriority: "high" };
            const startingPrice = (_a = item.action) == null ? void 0 : _a.startingPrice;
            const eventType = resolveProductEventType(item.action);
            const hasContent = item.title || startingPrice;
            const subContent = typeof startingPrice === "number" || eventType;
            return /* @__PURE__ */ jsx4(
              "div",
              {
                className: "group mx-auto flex h-full w-full shrink-0 items-center justify-center sm:container",
                children: /* @__PURE__ */ jsx4(
                  Button2,
                  {
                    as: href ? Link2 : "div",
                    theme: "transparent",
                    shape: "text",
                    href,
                    target: external ? "_blank" : void 0,
                    className: "border-paper relative h-full basis-full flex-col justify-between rounded-none p-0 sm:rounded-lg sm:border",
                    onClick: () => {
                      var _a2;
                      trackEvent({
                        event: "clicked_on_section_item",
                        data: {
                          type: item.__typename,
                          item_id: (_a2 = item.sys) == null ? void 0 : _a2.id,
                          slug: href,
                          label: item.title,
                          section: section.id,
                          position: index
                        }
                      });
                    },
                    children: /* @__PURE__ */ jsxs3("div", { className: "aspect-1 h-full w-full sm:aspect-[3/1]", children: [
                      /* @__PURE__ */ jsx4(
                        ContentfulMedia_default,
                        __spreadValues({
                          media: (_b = item.kv) == null ? void 0 : _b.image31,
                          poster: (_d = (_c = item.kv) == null ? void 0 : _c.image31) == null ? void 0 : _d.url,
                          className: "hidden h-full w-full overflow-hidden object-cover object-center sm:block",
                          ratio: "3x1",
                          placeholder: true,
                          controls: true
                        }, isLcp && desktop ? lcpProps : {})
                      ),
                      /* @__PURE__ */ jsx4(
                        ContentfulMedia_default,
                        __spreadValues({
                          media: (_e = item.kv) == null ? void 0 : _e.image11,
                          poster: (_g = (_f = item.kv) == null ? void 0 : _f.image31) == null ? void 0 : _g.url,
                          className: "h-full w-full overflow-hidden object-cover object-center sm:hidden",
                          width: 800,
                          height: 800,
                          fit: "thumb",
                          ratio: "1x1",
                          placeholder: true,
                          controls: true
                        }, isLcp && !desktop ? lcpProps : {})
                      ),
                      hasContent && /* @__PURE__ */ jsxs3(Fragment4, { children: [
                        /* @__PURE__ */ jsx4("div", { className: "absolute bottom-0 left-0 right-0 z-10 flex items-center justify-between p-4 text-white", children: /* @__PURE__ */ jsxs3("div", { className: "gap-y-M md:gap-y-L flex flex-col", children: [
                          /* @__PURE__ */ jsxs3("div", { className: "gap-y-S flex flex-col items-start", children: [
                            /* @__PURE__ */ jsx4(Typography3, { as: "h2", variant: "heading-XXL", className: "text-start", children: item.title }),
                            ((_h = item == null ? void 0 : item.location) == null ? void 0 : _h.address) && /* @__PURE__ */ jsx4(Typography3, { variant: "label-L", className: "text-start", children: (_i = item == null ? void 0 : item.location) == null ? void 0 : _i.address })
                          ] }),
                          subContent && /* @__PURE__ */ jsxs3("div", { className: "gap-y-XXS flex flex-col", children: [
                            typeof startingPrice === "number" ? startingPrice > 0 ? /* @__PURE__ */ jsxs3("div", { className: "gap-x-XXS flex flex-row items-center justify-start", children: [
                              /* @__PURE__ */ jsx4(Typography3, { variant: "body-L", color: "text-secondary", strong: true, children: t("contentful_common:starts_from") }),
                              /* @__PURE__ */ jsx4(
                                CurrencyPriceLabel2,
                                {
                                  originalPrice: startingPrice,
                                  currency: (_j = item.action) == null ? void 0 : _j.currencyCode,
                                  priceClassName: "text-body-L",
                                  currencyClassName: "text-label-M"
                                }
                              )
                            ] }) : /* @__PURE__ */ jsx4(
                              Typography3,
                              {
                                variant: "body-L",
                                className: "text-tertiary w-full text-start font-bold",
                                children: t("contentful_common:free")
                              }
                            ) : null,
                            /* @__PURE__ */ jsx4(BookingType_default, { className: "py-0.5", type: eventType, mini: true })
                          ] })
                        ] }) }),
                        /* @__PURE__ */ jsx4("div", { className: "absolute bottom-0 left-0 right-0 h-[80%] bg-gradient-to-t from-black/90 from-[10%] via-black/20 via-[70%] to-transparent to-[100%]" })
                      ] })
                    ] })
                  }
                )
              },
              item.id
            );
          })
        }
      )
    }
  );
};
var FullScreenGeoCarousel_default = FullScreenGeoCarousel;

// src/components/product/sections/GroupTagCarousel.tsx
import { useState } from "react";
import { twMerge as twMerge2 } from "tailwind-merge";
import { Button as Button3, Carousel as Carousel4, Paper, Typography as Typography4 } from "@wbk/ui";
import { ChevronIcon } from "@wbk/svg";
import { Link as Link3, useRouter as useRouter4, useTranslation as useTranslation3 } from "@wbk/config";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var COLLAPSED_LIMIT = 4;
var GroupTagCarousel = ({ section }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation3("contentful_event");
  const { locale } = useRouter4();
  const [expanded, setExpanded] = useState(false);
  const tags = ((_a = section.tagsCollection) == null ? void 0 : _a.items) || [];
  const parsedItems = (_d = (_c = (_b = section.contentCollection) == null ? void 0 : _b.items) == null ? void 0 : _c.map((item) => parseSectionItem({ item, locale })).filter(Boolean)) != null ? _d : [];
  const getAllTagEvents = (tagId) => parsedItems.filter((item) => {
    var _a2, _b2;
    return (_b2 = (_a2 = item == null ? void 0 : item.cmsTagsCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b2.some((t2) => t2.id === tagId);
  });
  if (!tags.length || !parsedItems.length) return null;
  return /* @__PURE__ */ jsx5(DecoratedSection_default, { section, className: "container", children: /* @__PURE__ */ jsx5(
    Carousel4,
    {
      options: { dragFree: true },
      arrows: "top",
      title: /* @__PURE__ */ jsxs4("div", { children: [
        section.title && /* @__PURE__ */ jsx5(Typography4, { as: "h2", variant: "heading-L", children: section.title }),
        section.subtitle && /* @__PURE__ */ jsx5(Typography4, { color: "text-secondary", className: "mt-1", children: section.subtitle })
      ] }),
      children: tags.map((tag) => {
        var _a2, _b2;
        const allEvents = getAllTagEvents(tag.id);
        const tagEvents = expanded ? allEvents : allEvents.slice(0, COLLAPSED_LIMIT);
        const hasMore = allEvents.length > COLLAPSED_LIMIT;
        return /* @__PURE__ */ jsxs4(
          Paper,
          {
            className: "relative m-2 flex min-h-96 shrink-0 basis-80 flex-col rounded-lg border bg-opacity-20 !p-0",
            children: [
              /* @__PURE__ */ jsxs4("div", { className: "relative w-full shrink-0 p-4", children: [
                tag.background && /* @__PURE__ */ jsx5("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx5(
                  ContentfulMedia_default,
                  {
                    media: tag.background,
                    className: "h-full w-full object-cover"
                  }
                ) }),
                tag.title && /* @__PURE__ */ jsxs4("div", { className: "my-4 space-y-1 text-center", children: [
                  /* @__PURE__ */ jsx5(Typography4, { variant: "heading-S", className: "line-clamp-1", children: tag.title }),
                  tag.subtitle && /* @__PURE__ */ jsx5(Typography4, { variant: "label-M", color: "text-secondary", className: "line-clamp-1", children: tag.subtitle })
                ] })
              ] }),
              tagEvents.length > 0 && /* @__PURE__ */ jsxs4("div", { className: "border-body-level-1 gap-S flex h-full flex-col border-y p-4", children: [
                tagEvents.map((item) => {
                  const clickable = !(item.__typename === "WebCard" && !item.href);
                  return /* @__PURE__ */ jsxs4(
                    Button3,
                    {
                      as: clickable ? Link3 : "div",
                      href: item.href,
                      theme: "transparent",
                      className: "bg-action/10 hover:bg-action/15 h-14 justify-between gap-2 text-start",
                      children: [
                        item.eventLogo || (item == null ? void 0 : item.icon) ? /* @__PURE__ */ jsx5(
                          ContentfulMedia_default,
                          {
                            media: item.eventLogo || (item == null ? void 0 : item.icon) || (item == null ? void 0 : item.image11),
                            className: twMerge2("max-h-12 w-auto", !clickable && "mx-auto")
                          }
                        ) : /* @__PURE__ */ jsx5(Typography4, { variant: "label-M", children: item.title }),
                        clickable && /* @__PURE__ */ jsxs4(
                          Typography4,
                          {
                            variant: "body-S",
                            as: "span",
                            className: "flex items-center gap-2",
                            children: [
                              (item == null ? void 0 : item.label) || t("contentful_event:buy"),
                              /* @__PURE__ */ jsx5(ChevronIcon, { className: "shrink-0 rtl:rotate-180" })
                            ]
                          }
                        )
                      ]
                    },
                    item.id
                  );
                }),
                hasMore && /* @__PURE__ */ jsx5(
                  Button3,
                  {
                    theme: "transparent",
                    className: "w-full pb-0 underline underline-offset-4",
                    shape: "text",
                    onClick: () => setExpanded((prev) => !prev),
                    children: expanded ? t("contentful_event:see_less") : t("contentful_event:see_more", {
                      count: allEvents.length - COLLAPSED_LIMIT
                    })
                  }
                )
              ] }),
              ((_b2 = (_a2 = section.webLinksCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b2[0]) && /* @__PURE__ */ jsx5("div", { className: "p-4", children: /* @__PURE__ */ jsx5(
                ContentfulButton_default,
                {
                  className: "h-12 w-full",
                  link: section.webLinksCollection.items[0]
                }
              ) })
            ]
          },
          tag.id
        );
      })
    }
  ) });
};
var GroupTagCarousel_default = GroupTagCarousel;

// src/components/product/sections/LongRectangularCarousel.tsx
import { Button as Button4, Carousel as Carousel5, Typography as Typography5 } from "@wbk/ui";
import { CurrencyPriceLabel as CurrencyPriceLabel3 } from "@wbk/currency";
import { useAnalytics as useAnalytics3 } from "@wbk/analytics";
import { Link as Link4, useRouter as useRouter5, useTranslation as useTranslation4 } from "@wbk/config";
import { Fragment as Fragment5, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var LongRectangularCarousel = ({ section }) => {
  const items = section.contentCollection.items;
  const { locale } = useRouter5();
  const { t } = useTranslation4("contentful_common");
  const { trackEvent } = useAnalytics3();
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx6(
    DecoratedSection_default,
    {
      section,
      "data-testid": `section_long_rectangular_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx6(
        Carousel5,
        {
          className: "pb-1",
          options: { dragFree: true },
          arrows: "top",
          arrowsClassName: "container",
          title: /* @__PURE__ */ jsxs5(Fragment5, { children: [
            section.title && /* @__PURE__ */ jsx6(Typography5, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx6(Typography5, { color: "text-secondary", className: "mt-1", children: section.subtitle })
          ] }),
          children: items.map((item, idx) => {
            var _a, _b, _c, _d;
            const parsedItem = parseSectionItem({ item, locale });
            if (!parsedItem) return null;
            const dealPrice = "deal" in item ? (_a = item.deal) == null ? void 0 : _a.price : 0;
            const discountedPrice = "discountedPrice" in item ? item.discountedPrice : 0;
            const price = dealPrice || discountedPrice || parsedItem.startingPrice;
            const hasContent = parsedItem.title || parsedItem.subtitle || parsedItem.startingPrice;
            const subContent = typeof parsedItem.startingPrice === "number" || (parsedItem == null ? void 0 : parsedItem.subtitle) || (parsedItem == null ? void 0 : parsedItem.eventType);
            const external = (_b = parsedItem.href) == null ? void 0 : _b.startsWith("http");
            return /* @__PURE__ */ jsx6(
              "div",
              {
                className: "group relative flex shrink-0 basis-5/6 sm:container md:basis-9/12 ltr:mr-3 rtl:ml-3",
                children: /* @__PURE__ */ jsx6(
                  Button4,
                  {
                    as: parsedItem.href ? Link4 : "div",
                    theme: "transparent",
                    shape: "text",
                    href: parsedItem.href,
                    target: external ? "_blank" : void 0,
                    className: "border-paper relative h-full basis-full flex-col justify-between rounded-none p-0 sm:rounded-lg sm:border",
                    onClick: () => {
                      var _a2;
                      trackEvent({
                        event: "clicked_on_section_item",
                        data: {
                          type: parsedItem.__typename,
                          item_id: (_a2 = parsedItem.sys) == null ? void 0 : _a2.id,
                          slug: parsedItem.href,
                          section: section.id,
                          position: idx
                        }
                      });
                    },
                    children: /* @__PURE__ */ jsxs5("div", { className: "aspect-1 h-full w-full sm:aspect-[3/1]", children: [
                      /* @__PURE__ */ jsx6(
                        ContentfulMedia_default,
                        {
                          media: parsedItem.image31,
                          poster: (_c = parsedItem.background) == null ? void 0 : _c.url,
                          className: "hidden h-full w-full overflow-hidden object-cover object-center sm:block",
                          ratio: "3x1",
                          placeholder: true,
                          controls: true
                        }
                      ),
                      /* @__PURE__ */ jsx6(
                        ContentfulMedia_default,
                        {
                          media: parsedItem.image11,
                          poster: (_d = parsedItem.background) == null ? void 0 : _d.url,
                          className: "h-full w-full overflow-hidden object-cover object-center sm:hidden",
                          width: 800,
                          height: 800,
                          fit: "thumb",
                          ratio: "1x1",
                          placeholder: true,
                          controls: true
                        }
                      ),
                      hasContent && /* @__PURE__ */ jsxs5(Fragment5, { children: [
                        /* @__PURE__ */ jsx6("div", { className: "absolute bottom-0 left-0 right-0 z-10 flex items-center justify-between p-4 text-white", children: /* @__PURE__ */ jsxs5("div", { className: "gap-y-S flex flex-col", children: [
                          /* @__PURE__ */ jsxs5("div", { className: "gap-y-S flex flex-col items-start", children: [
                            /* @__PURE__ */ jsx6(Typography5, { as: "h2", variant: "heading-S", className: "text-start", children: parsedItem.title }),
                            (parsedItem == null ? void 0 : parsedItem.subtitle) && /* @__PURE__ */ jsx6(Typography5, { children: parsedItem == null ? void 0 : parsedItem.subtitle })
                          ] }),
                          subContent && /* @__PURE__ */ jsxs5("div", { className: "gap-y-XXS flex flex-col", children: [
                            typeof parsedItem.startingPrice === "number" ? parsedItem.startingPrice > 0 ? /* @__PURE__ */ jsxs5("div", { className: "gap-x-XXS flex flex-row items-center justify-start", children: [
                              /* @__PURE__ */ jsx6(Typography5, { variant: "body-S", color: "text-secondary", strong: true, children: t("contentful_common:starts_from") }),
                              /* @__PURE__ */ jsx6(
                                CurrencyPriceLabel3,
                                {
                                  originalPrice: parsedItem.startingPrice,
                                  discountPrice: price,
                                  currency: parsedItem.currencyCode
                                }
                              )
                            ] }) : /* @__PURE__ */ jsx6(
                              Typography5,
                              {
                                variant: "body-S",
                                className: "text-tertiary w-full text-start font-bold",
                                children: t("contentful_common:free")
                              }
                            ) : null,
                            /* @__PURE__ */ jsx6(
                              BookingType_default,
                              {
                                className: "py-0.5",
                                type: parsedItem == null ? void 0 : parsedItem.eventType,
                                mini: true
                              }
                            )
                          ] })
                        ] }) }),
                        /* @__PURE__ */ jsx6("div", { className: "absolute bottom-0 left-0 right-0 h-[80%] bg-gradient-to-t from-black/90 from-[10%] via-black/20 via-[70%] to-transparent to-[100%]" })
                      ] })
                    ] })
                  }
                )
              },
              parsedItem.id
            );
          })
        }
      )
    }
  );
};
var LongRectangularCarousel_default = LongRectangularCarousel;

// src/components/product/sections/MasonryCarousel.tsx
import { useMemo as useMemo2 } from "react";
import { twMerge as twMerge3 } from "tailwind-merge";
import { Button as Button5, Carousel as Carousel6, Typography as Typography6 } from "@wbk/ui";
import { useAnalytics as useAnalytics4 } from "@wbk/analytics";
import { Link as Link5, useRouter as useRouter6 } from "@wbk/config";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var IMAGE_SIZE = {
  square: { width: 480, height: 480, sizes: "(min-width: 640px) 480px, 300px" },
  // fill crops the 1:1 / 3:1 fallbacks to 1:2, scaling them inside the box would leave them upscaled
  tall: { width: 240, height: 480, sizes: "(min-width: 640px) 232px, 145px", fit: "fill" },
  grid4: { width: 480, height: 480, sizes: "(min-width: 640px) 232px, 145px" },
  tallWithGrid2: { width: 480, height: 480, sizes: "(min-width: 640px) 232px, 145px" }
};
var MasonryCarousel = ({ section }) => {
  const items = section.contentCollection.items;
  const slides = useMemo2(() => {
    const result = [];
    let i = 0;
    let position = 1;
    while (i < items.length) {
      if (items[i]) {
        result.push({
          type: "square",
          items: [{ item: items[i], position }]
        });
        i++;
        position++;
      }
      const grid4Items = items.slice(i, i + 4);
      if (grid4Items.length > 0) {
        result.push({
          type: "grid4",
          items: grid4Items.map((item) => ({
            item,
            position: position++
          }))
        });
        i += grid4Items.length;
      }
      const compositeItems = items.slice(i, i + 3);
      if (compositeItems.length > 0) {
        result.push({
          type: "tallWithGrid2",
          items: compositeItems.map((item) => ({
            item,
            position: position++
          }))
        });
        i += compositeItems.length;
      }
    }
    return result;
  }, [items]);
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx7(DecoratedSection_default, { section, "data-testid": `section_odd_stacked_carousel_${section.id}`, children: /* @__PURE__ */ jsx7(
    Carousel6,
    {
      containerClassName: twMerge3("ms-2.5 sm:ms-4", items.length <= 8 && "xl:w-fit xl:mx-auto"),
      className: "pb-20",
      options: {
        align: "start",
        loop: true,
        active: items.length > 1,
        startIndex: 0
      },
      title: /* @__PURE__ */ jsxs6("div", { className: "container", children: [
        section.title && /* @__PURE__ */ jsx7(Typography6, { as: "h2", variant: "heading-L", children: section.title }),
        section.subtitle && /* @__PURE__ */ jsx7(Typography6, { color: "text-secondary", className: "mt-1", children: section.subtitle })
      ] }),
      children: slides.map((slide, idx) => {
        switch (slide.type) {
          case "square":
            return /* @__PURE__ */ jsx7(
              SquareCard,
              {
                item: slide.items[0].item,
                section,
                index: slide.items[0].position
              },
              idx
            );
          case "tallWithGrid2":
            return /* @__PURE__ */ jsx7(TallWithGrid2, { items: slide.items, section }, idx);
          case "grid4":
            return /* @__PURE__ */ jsx7(Grid4Cards, { items: slide.items, section }, idx);
          default:
            return null;
        }
      })
    }
  ) });
};
var MasonryCarousel_default = MasonryCarousel;
var BaseCard = ({ item, section, variant, index }) => {
  var _a, _b;
  const { trackEvent } = useAnalytics4();
  const { locale } = useRouter6();
  const parsedItem = parseSectionItem({ item, locale });
  if (!parsedItem) return null;
  const external = (_a = parsedItem.href) == null ? void 0 : _a.startsWith("http");
  const image = variant === "tall" ? (parsedItem == null ? void 0 : parsedItem.image23) || (parsedItem == null ? void 0 : parsedItem.image11) || (parsedItem == null ? void 0 : parsedItem.image31) : parsedItem == null ? void 0 : parsedItem.image11;
  return /* @__PURE__ */ jsx7(
    Button5,
    {
      as: parsedItem.href ? Link5 : "div",
      theme: "transparent",
      shape: "text",
      href: parsedItem.href || void 0,
      target: external ? "_blank" : void 0,
      className: twMerge3(
        "rounded-L h-full w-full p-0",
        parsedItem.href && "transition-transform duration-100 active:scale-95"
      ),
      onClick: () => {
        var _a2;
        trackEvent({
          event: "clicked_on_section_item",
          data: {
            type: parsedItem.__typename,
            item_id: (_a2 = parsedItem.sys) == null ? void 0 : _a2.id,
            slug: parsedItem.href,
            section: section.id,
            position: index
          }
        });
      },
      children: /* @__PURE__ */ jsx7(
        ContentfulMedia_default,
        __spreadValues(__spreadProps(__spreadValues({
          media: image,
          poster: (_b = parsedItem.background) == null ? void 0 : _b.url,
          className: twMerge3("h-full w-full object-cover object-center")
        }, IMAGE_SIZE[variant]), {
          placeholder: true,
          controls: true,
          width: 480,
          height: 480
        }), index === 1 ? { loading: "eager", fetchPriority: "high" } : {})
      )
    }
  );
};
var SquareCard = ({
  item,
  section,
  index
}) => {
  return /* @__PURE__ */ jsx7("div", { className: "aspect-1 w-[300px] shrink-0 sm:w-[480px] ltr:mr-2.5 sm:ltr:mr-4 rtl:ml-2.5 sm:rtl:ml-4", children: /* @__PURE__ */ jsx7(BaseCard, { item, section, variant: "square", index }) });
};
var TallWithGrid2 = ({ items, section }) => {
  const [tallItem, ...grid2Items] = items;
  return /* @__PURE__ */ jsx7("div", { className: "aspect-1 w-[300px] shrink-0 sm:w-[480px] ltr:mr-2.5 sm:ltr:mr-4 rtl:ml-2.5 sm:rtl:ml-4", children: /* @__PURE__ */ jsxs6("div", { className: "grid grid-cols-2 gap-2.5 sm:gap-4", children: [
    /* @__PURE__ */ jsx7("div", { className: "aspect-[1/2] h-full w-full", children: /* @__PURE__ */ jsx7(
      BaseCard,
      {
        item: tallItem.item,
        section,
        variant: "tall",
        index: tallItem.position
      }
    ) }),
    /* @__PURE__ */ jsx7("div", { className: "grid grid-rows-2 gap-2.5 sm:gap-4", children: grid2Items.map(({ item, position }) => /* @__PURE__ */ jsx7(
      BaseCard,
      {
        item,
        section,
        variant: "tallWithGrid2",
        index: position
      },
      position
    )) })
  ] }) });
};
var Grid4Cards = ({ items, section }) => {
  return /* @__PURE__ */ jsx7("div", { className: "aspect-1 w-[300px] shrink-0 sm:w-[480px] ltr:mr-2.5 sm:ltr:mr-4 rtl:ml-2.5 sm:rtl:ml-4", children: /* @__PURE__ */ jsxs6("div", { className: "grid grid-cols-2 gap-2.5 sm:gap-4", children: [
    items.map(({ item, position }) => /* @__PURE__ */ jsx7(BaseCard, { item, section, variant: "grid4", index: position }, position)),
    " "
  ] }) });
};

// src/components/product/sections/MiniListItems.tsx
import { Button as Button6, Typography as Typography7 } from "@wbk/ui";
import { ChevronIcon as ChevronIcon2 } from "@wbk/svg";
import { useAnalytics as useAnalytics5 } from "@wbk/analytics";
import { Link as Link6, useRouter as useRouter7 } from "@wbk/config";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var MiniListItems = ({ section }) => {
  const items = section.contentCollection.items;
  const { locale } = useRouter7();
  const { trackEvent } = useAnalytics5();
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs7(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_mini_list_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs7("div", { className: "space-y-1", children: [
          section.title && /* @__PURE__ */ jsx8(Typography7, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx8(Typography7, { color: "text-secondary", className: "mt-1", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx8("div", { className: "space-y-M", children: items.map((item, idx) => {
          var _a, _b;
          const parsedItem = parseSectionItem({ item, locale });
          if (!parsedItem) return null;
          const external = (_a = parsedItem.href) == null ? void 0 : _a.startsWith("http");
          return /* @__PURE__ */ jsxs7(
            Button6,
            {
              as: parsedItem.href ? Link6 : "div",
              theme: "action",
              shape: "text",
              href: parsedItem.href,
              target: external ? "_blank" : void 0,
              className: "gap-S relative flex h-full items-center justify-start p-0 pe-2.5",
              onClick: () => {
                var _a2;
                trackEvent({
                  event: "clicked_on_section_item",
                  data: {
                    type: parsedItem.__typename,
                    item_id: (_a2 = parsedItem.sys) == null ? void 0 : _a2.id,
                    slug: parsedItem.href,
                    section: section.id,
                    position: idx
                  }
                });
              },
              children: [
                /* @__PURE__ */ jsx8(
                  ContentfulMedia_default,
                  {
                    media: parsedItem.image11,
                    poster: (_b = parsedItem.background) == null ? void 0 : _b.url,
                    className: "aspect-1 rounded-S h-full w-full max-w-12 shrink-0 overflow-hidden object-cover object-center",
                    width: 800,
                    height: 800,
                    fit: "thumb",
                    ratio: "1x1",
                    placeholder: true,
                    controls: true
                  }
                ),
                /* @__PURE__ */ jsxs7("div", { className: "space-y-XXS grow p-0.5 text-start", children: [
                  /* @__PURE__ */ jsx8(Typography7, { variant: "label-L", className: "line-clamp-2", children: parsedItem.title }),
                  parsedItem.subtitle && /* @__PURE__ */ jsx8(Typography7, { variant: "label-S", color: "text-secondary", children: parsedItem.subtitle })
                ] }),
                /* @__PURE__ */ jsx8(ChevronIcon2, { className: "text-text-secondary shrink-0" })
              ]
            },
            parsedItem.id
          );
        }) })
      ]
    }
  );
};
var MiniListItems_default = MiniListItems;

// src/components/product/sections/WhatsNewSection.tsx
import { Fragment as Fragment6 } from "react";
import { Carousel as Carousel7, Typography as Typography8 } from "@wbk/ui";
import { useRouter as useRouter8 } from "@wbk/config";
import { Fragment as Fragment7, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var query2 = {
  limit: 10,
  order: ["order_ASC", "sys_firstPublishedAt_DESC"]
};
var WhatsNewSection = ({ section }) => {
  const { locale } = useRouter8();
  const { data: exploreData, isLoading } = useGetExplore(__spreadProps(__spreadValues({}, query2), {
    lang: locale,
    entities: ["product"],
    where: {
      action: { type_not: "coming_soon" }
    }
  }));
  const items = (exploreData == null ? void 0 : exploreData.data) || [];
  if (!(items == null ? void 0 : items.length) && !isLoading) {
    return null;
  }
  return /* @__PURE__ */ jsx9(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_whats_noew_${section.id}`,
      children: /* @__PURE__ */ jsx9(
        Carousel7,
        {
          className: "p-1",
          options: { dragFree: true },
          title: /* @__PURE__ */ jsxs8(Fragment7, { children: [
            section.title && /* @__PURE__ */ jsx9(Typography8, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx9(Typography8, { color: "text-secondary", className: "mt-1", children: section.subtitle })
          ] }),
          arrows: "top",
          children: isLoading ? [...new Array(10)].map((_, i) => /* @__PURE__ */ jsx9("div", { className: "relative shrink-0 basis-56 md:basis-60 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx9(ProductItemSkeleton, {}) }, i)) : items.map((event, i) => /* @__PURE__ */ jsx9(Fragment6, { children: /* @__PURE__ */ jsx9("div", { className: "relative shrink-0 basis-56 md:basis-60 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx9(
            Item_default,
            {
              item: event,
              cardType: section.itemRenderType,
              section: { id: section.id },
              index: i
            }
          ) }) }, i))
        }
      )
    }
  );
};
var WhatsNewSection_default = WhatsNewSection;

// src/components/product/sections/GridCarousel.tsx
import { Fragment as Fragment8 } from "react";
import { twMerge as twMerge4 } from "tailwind-merge";
import { jsx as jsx10 } from "react/jsx-runtime";
var ProductsGridCarousel = ({ section, className }) => {
  const events = section.contentCollection.items;
  if (!(events == null ? void 0 : events.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx10(
    DecoratedSection_default,
    {
      section,
      className: twMerge4("container", className),
      "data-testid": `section_events_grid_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx10(
        CarouselWithLink_default,
        {
          section,
          linkClassName: "relative shrink-0 basis-56 md:basis-60 aspect-1",
          children: events.map((event, i) => /* @__PURE__ */ jsx10(Fragment8, { children: /* @__PURE__ */ jsx10("div", { className: "relative shrink-0 basis-56 md:basis-60 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx10(
            Item_default,
            {
              item: event,
              cardType: section.itemRenderType,
              section,
              index: i
            }
          ) }) }, i))
        }
      )
    }
  );
};
var GridCarousel_default = ProductsGridCarousel;

// src/components/product/sections/FocusedCarousel.tsx
import { useCallback, useEffect, useRef, useState as useState2 } from "react";
import { flushSync } from "react-dom";
import { Carousel as Carousel8, Typography as Typography9 } from "@wbk/ui";
import { useRouter as useRouter9 } from "@wbk/config";
import { Fragment as Fragment9, jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var TWEEN_FACTOR = 1;
var numberWithinRange = (number, min, max) => Math.min(Math.max(number, min), max);
var ProductsFocusedCarousel = ({ section }) => {
  const events = section.contentCollection.items;
  const { locale } = useRouter9();
  const [carousel, setCarousel] = useState2();
  const slidesRef = useRef([]);
  const onScroll = useCallback(() => {
    if (!carousel) return;
    const engine = carousel.internalEngine();
    const scrollProgress = carousel.scrollProgress();
    const dir = (locale == null ? void 0 : locale.startsWith("ar")) ? 1 : -1;
    carousel.scrollSnapList().map((scrollSnap, index) => {
      let diffToTarget = scrollSnap - scrollProgress;
      let sign = Math.sign(diffToTarget);
      engine.slideLooper.loopPoints.forEach((loopItem) => {
        const target = loopItem.target();
        if (index === loopItem.index && target !== 0) {
          sign = Math.sign(target);
          if (sign === -1) diffToTarget = scrollSnap - (1 + scrollProgress);
          if (sign === 1) diffToTarget = scrollSnap + (1 - scrollProgress);
        }
      });
      const tweenValue = 1 - Math.abs(diffToTarget * TWEEN_FACTOR);
      const scale = numberWithinRange(tweenValue, 0, 1);
      const slide = slidesRef.current[index];
      if (!slide) return;
      slide.style.transform = `translateX(${100 * (1 - scale) * diffToTarget * 3.5 * dir}%) scale(${scale})`;
    });
  }, [carousel, locale]);
  useEffect(() => {
    if (!carousel) return;
    onScroll();
    carousel.on("scroll", () => {
      flushSync(() => onScroll());
    });
    carousel.on("reInit", onScroll);
  }, [carousel, onScroll]);
  return /* @__PURE__ */ jsx11(
    DecoratedSection_default,
    {
      section,
      className: "container relative",
      "data-testid": `section_events_focused_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx11(
        Carousel8,
        {
          options: { align: "center", loop: true },
          className: "py-0.5",
          onInit: (carousel2) => {
            setCarousel(carousel2);
          },
          title: /* @__PURE__ */ jsxs9(Fragment9, { children: [
            section.title && /* @__PURE__ */ jsx11(Typography9, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx11(Typography9, { color: "text-secondary", className: "mt-1", children: section.subtitle })
          ] }),
          arrows: "top",
          children: events.map((event, i) => {
            var _a;
            return /* @__PURE__ */ jsx11("div", { className: "flex shrink-0 basis-80 px-2 py-4 md:basis-[300px]", children: /* @__PURE__ */ jsx11(
              "div",
              {
                className: "flex h-full w-full",
                ref: (el) => {
                  if (el) {
                    slidesRef.current[i] = el;
                  }
                },
                children: /* @__PURE__ */ jsx11(
                  Item_default,
                  {
                    item: event,
                    cardType: section.itemRenderType,
                    section,
                    index: i
                  }
                )
              }
            ) }, (_a = event.sys) == null ? void 0 : _a.id);
          })
        }
      )
    }
  );
};
var FocusedCarousel_default = ProductsFocusedCarousel;

// src/components/product/sections/GeoSection.tsx
import { useEffect as useEffect2, useMemo as useMemo3, useState as useState3 } from "react";
import { Button as Button7, DayPicker, Menu, ResponsivePopover, Slider, Typography as Typography10 } from "@wbk/ui";
import { endOfDay, formatDate, formatPrice, parseDate, startOfDay } from "@wbk/utils";
import { useCurrency } from "@wbk/currency";
import { ChevronIcon as ChevronIcon3 } from "@wbk/svg";
import { useRouter as useRouter10, useTranslation as useTranslation5 } from "@wbk/config";
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var DEFAULT_LIMIT = 10;
var ProductsGeoSection = ({ section }) => {
  var _a, _b, _c;
  const { locale, search } = useRouter10();
  const { t } = useTranslation5(["common", "contentful_event"]);
  const { currency } = useCurrency();
  const getInitialSelectedCity = (search2) => {
    var _a2;
    return (_a2 = search2.get("destination")) != null ? _a2 : "";
  };
  const getInitialSelectedDate = (search2) => {
    const arrival = search2.get("arrival_date");
    if (!arrival) return void 0;
    const parsed = parseDate(arrival);
    return { from: parsed, to: void 0 };
  };
  const [selectedCity, setSelectedCity] = useState3(() => getInitialSelectedCity(search));
  const [selectedDate, setSelectedDate] = useState3(
    () => getInitialSelectedDate(search)
  );
  const { data: cityData, isLoading: isCityLoading } = useGetCity({
    lang: locale
  });
  const { data: maxPriceData } = useGetProductsList({
    lang: locale,
    limit: 1,
    order: "action_startingPrice_DESC"
  });
  const highestMaxPrice = ((_c = (_b = (_a = maxPriceData == null ? void 0 : maxPriceData.items) == null ? void 0 : _a[0]) == null ? void 0 : _b.action) == null ? void 0 : _c.startingPrice) || 0;
  const [priceRange, setPriceRange] = useState3([0, 0]);
  const [isPriceFilterApplied, setIsPriceFilterApplied] = useState3(false);
  useEffect2(() => {
    if (highestMaxPrice && !isPriceFilterApplied) {
      setPriceRange([0, highestMaxPrice]);
    }
  }, [highestMaxPrice, isPriceFilterApplied]);
  const query3 = useMemo3(() => {
    const filters3 = [];
    if (selectedCity) {
      filters3.push({ location: { cityCode: selectedCity } });
    }
    if ((selectedDate == null ? void 0 : selectedDate.from) && (selectedDate == null ? void 0 : selectedDate.to)) {
      const from = startOfDay(new Date(selectedDate.from));
      const to = endOfDay(new Date(selectedDate.to));
      filters3.push({
        OR: [
          { schedule: { openDateTime_lte: to, closeDateTime_gte: from } },
          { schedule: { openDateTime_gte: from, openDateTime_lte: to } },
          { schedule: { openDateTime_lte: to, closeDateTime_exists: false } }
        ]
      });
    }
    if (isPriceFilterApplied && priceRange[0] >= 0 && priceRange[1] > priceRange[0]) {
      filters3.push({
        action: { startingPrice_gte: priceRange[0], startingPrice_lte: priceRange[1] }
      });
    }
    if (section.tagsCollection.items.length > 0) {
      filters3.push({ tags: { slug_in: section.tagsCollection.items.map((tag) => tag.slug) } });
    }
    return {
      lang: locale,
      limit: DEFAULT_LIMIT,
      order: "sys_firstPublishedAt_DESC",
      where: filters3.length > 0 ? { AND: filters3 } : void 0
    };
  }, [
    locale,
    selectedCity,
    selectedDate,
    priceRange,
    isPriceFilterApplied,
    section.tagsCollection.items
  ]);
  const {
    data: items,
    isLoading: isEventsLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage
  } = useGetInfiniteProductsList(query3);
  const isLoading = isEventsLoading;
  const maxPrice = useMemo3(() => {
    if (items == null ? void 0 : items.length) {
      return items.reduce(
        (max, item) => {
          var _a2;
          return Math.max(max, ((_a2 = item.action) == null ? void 0 : _a2.startingPrice) || 0);
        },
        highestMaxPrice
      );
    }
    return highestMaxPrice;
  }, [items, highestMaxPrice]);
  const cityOptions = useMemo3(() => {
    return (cityData || []).map((city) => ({
      text: city.title,
      value: city.cityCode
    }));
  }, [cityData]);
  const dateLabel = useMemo3(() => {
    if (!(selectedDate == null ? void 0 : selectedDate.from)) return t("common:date");
    if (!selectedDate.to) return formatDate(selectedDate.from, locale, { dateStyle: "medium" });
    return `${formatDate(selectedDate.from, locale, { month: "short", day: "numeric" })} - ${formatDate(selectedDate.to, locale, { month: "short", day: "numeric" })}`;
  }, [selectedDate, locale, t]);
  const priceLabel = useMemo3(() => {
    const [from, to] = priceRange;
    if (from === 0 && to === maxPrice) return t("common:price");
    return `${formatPrice(from)} - ${formatPrice(to)} ${currency.shortCode}`;
  }, [priceRange, maxPrice, currency.shortCode, t]);
  const hasActiveFilters = selectedCity || (selectedDate == null ? void 0 : selectedDate.from) || isPriceFilterApplied;
  const resetFilters = () => {
    setSelectedCity("");
    setSelectedDate(void 0);
    setPriceRange([0, maxPrice]);
    setIsPriceFilterApplied(false);
  };
  if (!(items == null ? void 0 : items.length) && !isLoading && !hasActiveFilters) {
    return null;
  }
  return /* @__PURE__ */ jsxs10(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_events_geo_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsx12(Typography10, { as: "h2", variant: "heading-L", children: section.title }),
        section.subtitle && /* @__PURE__ */ jsx12(Typography10, { color: "text-secondary", className: "mt-1", children: section.subtitle }),
        /* @__PURE__ */ jsxs10("div", { className: "my-4 flex flex-wrap gap-2", children: [
          /* @__PURE__ */ jsx12(
            ResponsivePopover,
            {
              popover: {
                className: "min-w-[300px]",
                sideOffset: 8,
                align: "start",
                action: false,
                cancel: false
              },
              sheet: { action: false, cancel: false },
              render: ({ open }) => /* @__PURE__ */ jsxs10(Button7, { shape: "outlined", theme: "action", onClick: open, children: [
                dateLabel,
                /* @__PURE__ */ jsx12(ChevronIcon3, { className: "h-2 w-2 shrink-0 rotate-90 transition-transform duration-200" })
              ] }),
              body: ({ close }) => /* @__PURE__ */ jsxs10("div", { className: "space-y-4", children: [
                /* @__PURE__ */ jsx12(Typography10, { variant: "heading-S", children: t("common:select_date") }),
                /* @__PURE__ */ jsx12(
                  DayPicker,
                  {
                    lang: locale,
                    mode: "range",
                    selected: selectedDate,
                    onSelect: (range) => {
                      setSelectedDate(range);
                      if ((range == null ? void 0 : range.from) && (range == null ? void 0 : range.to)) close();
                    },
                    weekStartsOn: 0,
                    startMonth: /* @__PURE__ */ new Date()
                  }
                )
              ] })
            }
          ),
          /* @__PURE__ */ jsx12(
            Menu,
            {
              render: ({ open, selected }) => /* @__PURE__ */ jsxs10(
                Button7,
                {
                  shape: "outlined",
                  theme: "action",
                  onClick: open,
                  disabled: isCityLoading,
                  loading: isCityLoading,
                  children: [
                    (selected == null ? void 0 : selected.text) || t("common:city"),
                    /* @__PURE__ */ jsx12(ChevronIcon3, { className: "h-2 w-2 shrink-0 rotate-90" })
                  ]
                }
              ),
              value: selectedCity,
              onChange: (option) => setSelectedCity(option.value),
              options: [{ text: t("common:all_cities"), value: "" }, ...cityOptions],
              hideErrorSpace: true
            }
          ),
          /* @__PURE__ */ jsx12(
            ResponsivePopover,
            {
              popover: {
                className: "min-w-[300px]",
                sideOffset: 8,
                align: "start",
                action: false,
                cancel: false
              },
              sheet: { action: false, cancel: false },
              render: ({ open }) => /* @__PURE__ */ jsxs10(Button7, { shape: "outlined", theme: "action", onClick: open, children: [
                priceLabel,
                /* @__PURE__ */ jsx12(ChevronIcon3, { className: "h-2 w-2 shrink-0 rotate-90 transition-transform duration-200" })
              ] }),
              body: () => /* @__PURE__ */ jsxs10("div", { className: "space-y-6 pb-4", children: [
                /* @__PURE__ */ jsxs10("div", { children: [
                  /* @__PURE__ */ jsx12(Typography10, { variant: "heading-S", children: t("common:price_range") }),
                  /* @__PURE__ */ jsx12(
                    Typography10,
                    {
                      variant: "body-M",
                      color: "text-secondary",
                      dir: "ltr",
                      className: "rtl:text-end",
                      children: `${formatPrice(priceRange[0])} ${currency.shortCode} - ${formatPrice(priceRange[1])} ${currency.shortCode}`
                    }
                  )
                ] }),
                /* @__PURE__ */ jsx12(
                  Slider,
                  {
                    className: "[&_[role=slider]]:bg-paper",
                    "aria-labelledby": t("common:price_range"),
                    value: priceRange,
                    onValueChange: (val) => setPriceRange(val),
                    onValueCommit: () => setIsPriceFilterApplied(true),
                    minStepsBetweenThumbs: 1,
                    step: 5,
                    min: 0,
                    max: maxPrice,
                    theme: "action"
                  }
                )
              ] })
            }
          ),
          hasActiveFilters && /* @__PURE__ */ jsx12(
            Button7,
            {
              className: "underline underline-offset-2",
              shape: "text",
              theme: "transparent",
              onClick: resetFilters,
              children: t("contentful_event:reset_filters")
            }
          )
        ] }),
        /* @__PURE__ */ jsx12("div", { className: "grid grid-cols-2 gap-4 sm:grid-cols-[repeat(auto-fill,minmax(240px,1fr))]", children: isLoading && !items ? [...Array(8)].map((_, i) => /* @__PURE__ */ jsx12(ProductItemSkeleton, {}, i)) : (items == null ? void 0 : items.length) ? items.map((event, i) => /* @__PURE__ */ jsx12(
          Item_default,
          {
            item: event,
            cardType: section.itemRenderType,
            section: { id: section.id },
            index: i
          },
          event.id
        )) : /* @__PURE__ */ jsxs10("div", { className: "col-span-full flex w-full flex-col items-center justify-center gap-4 py-12", children: [
          /* @__PURE__ */ jsx12(Typography10, { variant: "label-M", children: t("contentful_event:no_events") }),
          /* @__PURE__ */ jsx12(Button7, { theme: "action", onClick: resetFilters, children: t("contentful_event:reset_filters") })
        ] }) }),
        hasNextPage && /* @__PURE__ */ jsx12("div", { className: "mt-6 flex w-full items-center justify-center", children: /* @__PURE__ */ jsx12(
          Button7,
          {
            theme: "action",
            shape: "outlined",
            onClick: () => fetchNextPage(),
            disabled: isFetchingNextPage,
            children: /* @__PURE__ */ jsx12(Typography10, { variant: "body-S", className: "text-center", children: t("common:load_more") })
          }
        ) })
      ]
    }
  );
};
var GeoSection_default = ProductsGeoSection;

// src/components/product/sections/Grid.tsx
import { Fragment as Fragment10 } from "react";
import { Typography as Typography11 } from "@wbk/ui";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var ProductsGrid = ({ section }) => {
  const events = section.contentCollection.items;
  if (!events.length) return null;
  return /* @__PURE__ */ jsxs11(
    DecoratedSection_default,
    {
      section,
      className: "container relative overflow-hidden",
      "data-testid": `section_events_grid_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs11("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx13(Typography11, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx13(Typography11, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx13("div", { className: "grid grid-cols-2 gap-4 sm:grid-cols-[repeat(auto-fill,minmax(240px,1fr))]", children: events.map((event) => {
          var _a;
          return /* @__PURE__ */ jsx13(Fragment10, { children: /* @__PURE__ */ jsx13(Item_default, { item: event, cardType: section.itemRenderType, section }) }, (_a = event.sys) == null ? void 0 : _a.id);
        }) })
      ]
    }
  );
};
var Grid_default = ProductsGrid;

// src/components/product/sections/ListItem.tsx
import { ClockIcon, LocationIcon } from "@wbk/svg";
import { formatDate as formatDate2 } from "@wbk/utils";
import { Button as Button8, Typography as Typography12 } from "@wbk/ui";
import { Link as Link7, useRouter as useRouter11, useTranslation as useTranslation6 } from "@wbk/config";
import { useAnalytics as useAnalytics6 } from "@wbk/analytics";
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var ProductListItems = ({ section }) => {
  const { locale } = useRouter11();
  const { t } = useTranslation6(["contentful_common"]);
  const events = section.contentCollection.items.map((item) => parseCardItem({ item })).filter((item) => !!item);
  const { trackEvent } = useAnalytics6();
  if (!events.length) return null;
  return /* @__PURE__ */ jsxs12(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_events_list_item_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs12("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx14(Typography12, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx14(Typography12, { color: "text-secondary", children: section.subtitle })
        ] }),
        events.map((event, i) => {
          var _a, _b, _c, _d;
          const startDate = ((_a = event.schedule) == null ? void 0 : _a.openDateTime) ? (_b = event.schedule) == null ? void 0 : _b.openDateTime : null;
          const notifyMe = !!((_c = event.eventType) == null ? void 0 : _c.includes("offline"));
          return /* @__PURE__ */ jsxs12(
            Button8,
            {
              as: Link7,
              href: `/${locale}${createSectionItemHref(event)}`,
              className: "border-paper flex w-full grow flex-col items-center gap-6 p-4 focus:ring-1 lg:flex-row",
              shape: "outlined",
              theme: "action",
              onClick: () => {
                var _a2;
                trackEvent({
                  event: "clicked_on_section_item",
                  data: {
                    type: event.__typename,
                    item_id: (_a2 = event.sys) == null ? void 0 : _a2.id,
                    slug: event.slug,
                    section: section.id,
                    position: i
                  }
                });
              },
              children: [
                /* @__PURE__ */ jsxs12("div", { className: "flex flex-1 justify-center gap-4 lg:items-center", children: [
                  startDate && /* @__PURE__ */ jsxs12("div", { className: "hidden w-20 truncate rounded-md text-center leading-none lg:block", children: [
                    /* @__PURE__ */ jsx14("p", { className: "text-base uppercase", children: formatDate2(startDate, locale, { month: "short" }) }),
                    /* @__PURE__ */ jsx14("p", { className: "text-4xl font-semibold", children: formatDate2(startDate, locale, { day: "2-digit" }) }),
                    /* @__PURE__ */ jsx14("p", { className: "text-base", children: formatDate2(startDate, locale, { year: "numeric" }) })
                  ] }),
                  /* @__PURE__ */ jsx14("div", { className: "bg-body-dark/10 hidden w-[1px] self-stretch lg:block" }),
                  /* @__PURE__ */ jsxs12("div", { className: "flex w-full flex-col items-center gap-4 lg:flex-row", children: [
                    /* @__PURE__ */ jsxs12("div", { className: "relative flex items-center gap-2", children: [
                      event.deal && /* @__PURE__ */ jsx14(Deal_default, { item: event }),
                      /* @__PURE__ */ jsx14(
                        ContentfulMedia_default,
                        {
                          media: event.image32 || event.image31,
                          className: "aspect-[3/2] rounded-md object-contain lg:w-[150px]"
                        }
                      ),
                      event.deal && /* @__PURE__ */ jsx14(Zone_default, { item: event, className: "bottom-0 top-auto" })
                    ] }),
                    /* @__PURE__ */ jsxs12("div", { className: "space-y-1 lg:text-start", children: [
                      /* @__PURE__ */ jsx14("p", { className: "mb-2 text-lg font-semibold lg:mb-0 lg:text-2xl", children: event.title }),
                      /* @__PURE__ */ jsxs12("div", { className: "flex flex-col items-center gap-2 text-sm lg:flex-row lg:gap-5", children: [
                        startDate && /* @__PURE__ */ jsxs12("div", { className: "hidden items-center gap-2 lg:flex", children: [
                          /* @__PURE__ */ jsx14(ClockIcon, { className: "text-text-secondary h-4 w-4 object-contain" }),
                          /* @__PURE__ */ jsx14("p", { className: "text-text-secondary text-base font-normal", children: formatDate2(startDate, locale, { timeStyle: "short" }).replace(
                            /\s/gi,
                            " "
                          ) })
                        ] }),
                        startDate && /* @__PURE__ */ jsx14("p", { className: "text-text-secondary text-base font-normal lg:hidden", children: formatDate2(startDate, locale, {
                          timeStyle: "short",
                          dateStyle: "long"
                        }) }),
                        /* @__PURE__ */ jsxs12("div", { className: "flex w-full items-center justify-center gap-2 lg:w-auto", children: [
                          /* @__PURE__ */ jsx14(LocationIcon, { className: "text-text-secondary hidden h-4 w-4 object-contain lg:block" }),
                          /* @__PURE__ */ jsx14("p", { className: "text-text-secondary text-base font-normal", children: (_d = event.location) == null ? void 0 : _d.title })
                        ] })
                      ] })
                    ] })
                  ] })
                ] }),
                notifyMe ? /* @__PURE__ */ jsxs12("div", { className: "flex flex-col items-center gap-2 lg:flex-row lg:gap-5", children: [
                  /* @__PURE__ */ jsx14("p", { className: "text-text-secondary text-sm", children: t("contentful_common:tickets_not_available") }),
                  /* @__PURE__ */ jsx14(
                    NotifyButton_default,
                    {
                      event: {
                        __typename: "event",
                        id: event.id,
                        title: event.title,
                        slug: event.slug
                      },
                      className: "py-S min-h-0 whitespace-nowrap",
                      theme: "action",
                      textVariant: "body-M"
                    }
                  )
                ] }) : /* @__PURE__ */ jsx14(
                  Button8,
                  {
                    className: "w-full max-w-xl whitespace-nowrap p-2 font-bold lg:max-w-fit lg:px-4 lg:py-3 lg:text-lg",
                    tabIndex: -1,
                    children: t("contentful_common:book_now")
                  }
                )
              ]
            },
            event.slug
          );
        })
      ]
    }
  );
};
var ListItem_default = ProductListItems;

// src/components/product/sections/ListItemDateCategorized.tsx
import { useMemo as useMemo4, useState as useState4 } from "react";
import { useAnalytics as useAnalytics7 } from "@wbk/analytics";
import { CurrencyPriceLabel as CurrencyPriceLabel4 } from "@wbk/currency";
import { Link as Link8, useRouter as useRouter12, useTranslation as useTranslation7 } from "@wbk/config";
import { ClockIcon as ClockIcon2, LocationIcon as LocationIcon2 } from "@wbk/svg";
import { formatDate as formatDate3 } from "@wbk/utils";
import { Button as Button9, Typography as Typography13 } from "@wbk/ui";
import { jsx as jsx15, jsxs as jsxs13 } from "react/jsx-runtime";
var filters = ["all", "upcoming", "past"];
var ProductListItemsDateCategorized = ({ section }) => {
  const { locale } = useRouter12();
  const { t } = useTranslation7(["contentful_common", "contentful_event"]);
  const { trackEvent } = useAnalytics7();
  const [filter, setFilter] = useState4("all");
  const events = section.contentCollection.items.filter((item) => resolveContentfulEventType(item) === "events").map((item) => parseCardItem({ item })).filter((item) => !!item);
  const categorized = useMemo4(() => {
    const now = /* @__PURE__ */ new Date();
    return {
      all: events,
      upcoming: events.filter((e) => {
        var _a;
        return new Date(((_a = e.schedule) == null ? void 0 : _a.openDateTime) || 0) > now;
      }),
      past: events.filter((e) => {
        var _a;
        return new Date(((_a = e.schedule) == null ? void 0 : _a.openDateTime) || 0) < now;
      })
    };
  }, [events]);
  const groupedEvents = useMemo4(() => {
    return groupEventsByDay(categorized[filter], locale);
  }, [categorized, filter, locale]);
  return /* @__PURE__ */ jsxs13(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_events_list_item_date_grouped_${section.id}`,
      children: [
        (section == null ? void 0 : section.title) && /* @__PURE__ */ jsxs13("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx15(Typography13, { as: "h2", variant: "heading-L", children: section == null ? void 0 : section.title }),
          (section == null ? void 0 : section.subtitle) && /* @__PURE__ */ jsx15(Typography13, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx15("div", { className: "gap-S mt-M flex", children: filters.map((f) => /* @__PURE__ */ jsx15(
          Button9,
          {
            shape: "outlined",
            theme: "action",
            onClick: () => setFilter(f),
            "data-active": filter === f,
            className: "border-paper-level-1 text-paper-level-3 data-[active=true]:border-action data-[active=true]:text-action",
            children: /* @__PURE__ */ jsx15(Typography13, { variant: "label-M", children: t(`contentful_common:filters.${f}`) })
          },
          f
        )) }),
        /* @__PURE__ */ jsx15("div", { className: "space-y-M md:space-y-L", children: groupedEvents && groupedEvents.length === 0 ? /* @__PURE__ */ jsxs13("div", { className: "flex h-72 w-full flex-col items-center justify-center", children: [
          /* @__PURE__ */ jsx15(Typography13, { variant: "heading-L", className: "mb-4 mt-8 hidden md:block", children: t("contentful_event:no_events") }),
          /* @__PURE__ */ jsx15(Button9, { theme: "action", onClick: () => setFilter("all"), children: t("contentful_event:reset_filters") })
        ] }) : groupedEvents == null ? void 0 : groupedEvents.map((group) => /* @__PURE__ */ jsxs13("div", { className: "w-full", children: [
          /* @__PURE__ */ jsx15(Typography13, { variant: "heading-XS", className: "mb-4 mt-8 hidden md:block", children: group.displayDate }),
          /* @__PURE__ */ jsx15("div", { className: "space-y-M", children: group.events.map((event, index) => {
            var _a, _b, _c, _d;
            const resolvedType = resolveContentfulEventType(event);
            const startDate = (_b = (_a = event.schedule) == null ? void 0 : _a.openDateTime) != null ? _b : null;
            const notifyMe = !!((_c = event.eventType) == null ? void 0 : _c.includes("offline"));
            return /* @__PURE__ */ jsxs13(
              Button9,
              {
                as: Link8,
                to: `/${locale}/${resolvedType}/${event.slug}`,
                className: "gap-M py-S border-paper w-full items-end focus:ring-1 md:items-center",
                shape: "outlined",
                theme: "action",
                onClick: () => {
                  var _a2;
                  trackEvent({
                    event: "clicked_on_section_item",
                    data: {
                      type: event.__typename,
                      item_id: (_a2 = event.sys) == null ? void 0 : _a2.id,
                      slug: event.slug,
                      section: section.id,
                      position: index
                    }
                  });
                },
                children: [
                  /* @__PURE__ */ jsxs13("div", { className: "gap-M flex w-full flex-col-reverse items-start md:flex-row md:items-center", children: [
                    event.image32 && /* @__PURE__ */ jsx15(ContentfulMedia_default, { media: event.image32, className: "max-h-10 w-auto" }),
                    /* @__PURE__ */ jsxs13("div", { className: "space-y-XXS text-start", children: [
                      /* @__PURE__ */ jsx15(
                        Typography13,
                        {
                          variant: "body-S",
                          color: "text-secondary",
                          className: "hidden md:block",
                          children: event.subtitle
                        }
                      ),
                      /* @__PURE__ */ jsx15(Typography13, { variant: "label-L", className: "hidden md:block", children: event.title }),
                      /* @__PURE__ */ jsxs13("div", { className: "gap-x-XS gap-y-XXS flex flex-col items-start md:flex-row md:items-center", children: [
                        startDate && /* @__PURE__ */ jsxs13("div", { className: "gap-XXS hidden items-center md:flex", children: [
                          /* @__PURE__ */ jsx15(ClockIcon2, { className: "text-text-secondary h-5 w-5 object-contain" }),
                          /* @__PURE__ */ jsx15(Typography13, { variant: "body-S", color: "text-secondary", children: formatDate3(startDate, locale, { timeStyle: "short" }) })
                        ] }),
                        startDate && /* @__PURE__ */ jsx15(Typography13, { variant: "label-S", className: "md:hidden", children: formatDate3(startDate, locale, {
                          timeStyle: "short",
                          dateStyle: "long"
                        }) }),
                        /* @__PURE__ */ jsxs13("div", { className: "gap-XXS flex w-full items-start justify-start md:w-auto md:items-center", children: [
                          /* @__PURE__ */ jsx15(LocationIcon2, { className: "text-text-secondary hidden h-4 w-4 object-contain md:block" }),
                          /* @__PURE__ */ jsx15(Typography13, { variant: "body-S", color: "text-secondary", children: (_d = event == null ? void 0 : event.location) == null ? void 0 : _d.title })
                        ] })
                      ] })
                    ] })
                  ] }),
                  notifyMe ? /* @__PURE__ */ jsxs13("div", { className: "gap-S md:gap-M flex w-auto flex-col items-center md:flex-row", children: [
                    /* @__PURE__ */ jsx15(
                      Typography13,
                      {
                        variant: "body-S",
                        color: "text-secondary",
                        className: "whitespace-nowrap",
                        children: t("contentful_common:tickets_not_available")
                      }
                    ),
                    /* @__PURE__ */ jsx15(
                      NotifyButton_default,
                      {
                        event,
                        className: "py-S min-h-0 whitespace-nowrap",
                        theme: "action",
                        textVariant: "body-M"
                      }
                    )
                  ] }) : /* @__PURE__ */ jsxs13("div", { className: "gap-M flex shrink-0 flex-col items-center md:flex-row", children: [
                    /* @__PURE__ */ jsxs13(
                      "div",
                      {
                        "data-resell": event.showResellBanner,
                        className: "flex items-end gap-1.5 data-[resell=true]:hidden md:data-[resell=true]:flex",
                        children: [
                          /* @__PURE__ */ jsx15(Typography13, { variant: "body-S", color: "text-secondary", children: t("contentful_common:starts_from") }),
                          /* @__PURE__ */ jsx15(
                            CurrencyPriceLabel4,
                            {
                              originalPrice: event.startingPrice || 0,
                              currency: event.currencyCode
                            }
                          )
                        ]
                      }
                    ),
                    event.showResellBanner && /* @__PURE__ */ jsxs13("div", { className: "space-y-S md:space-y-0", children: [
                      /* @__PURE__ */ jsx15(Typography13, { variant: "body-S", color: "error", className: "md:hidden", children: t("contentful_event:sold_out") }),
                      /* @__PURE__ */ jsx15("object", { children: /* @__PURE__ */ jsx15(
                        Button_default,
                        {
                          className: "whitespace-nowrap",
                          theme: "action",
                          shape: "outlined",
                          slug: event.slug,
                          title: /* @__PURE__ */ jsx15(Typography13, { children: t("contentful_event:resell.check_resale") })
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ jsx15(
                      Button9,
                      {
                        "data-resell": event.showResellBanner,
                        className: "w-full max-w-xl whitespace-nowrap font-bold data-[resell=true]:hidden md:max-w-fit md:data-[resell=true]:block",
                        children: t("contentful_common:book_now")
                      }
                    )
                  ] })
                ]
              },
              event.slug
            );
          }) })
        ] }, group.dayKey)) })
      ]
    }
  );
};
var ListItemDateCategorized_default = ProductListItemsDateCategorized;

// src/components/product/sections/ListItemDateGrouped.tsx
import { useMemo as useMemo5 } from "react";
import { useAnalytics as useAnalytics8 } from "@wbk/analytics";
import { CurrencyPriceLabel as CurrencyPriceLabel5 } from "@wbk/currency";
import { Link as Link9, useRouter as useRouter13, useTranslation as useTranslation8 } from "@wbk/config";
import { ClockIcon as ClockIcon3, LocationIcon as LocationIcon3 } from "@wbk/svg";
import { formatDate as formatDate4 } from "@wbk/utils";
import { Button as Button10, Typography as Typography14 } from "@wbk/ui";
import { jsx as jsx16, jsxs as jsxs14 } from "react/jsx-runtime";
var ProductListItemsDateGrouped = ({ section }) => {
  const { locale } = useRouter13();
  const { t } = useTranslation8(["contentful_common"]);
  const events = section.contentCollection.items.filter((item) => resolveContentfulEventType(item) === "events").map((item) => parseCardItem({ item })).filter((item) => !!item);
  const { trackEvent } = useAnalytics8();
  const groupedEvents = useMemo5(
    () => groupEventsByDay(events, locale),
    [events, locale]
  );
  if (!(groupedEvents == null ? void 0 : groupedEvents.length)) return null;
  return /* @__PURE__ */ jsxs14(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_events_list_item_date_grouped_${section.id}`,
      children: [
        (section == null ? void 0 : section.title) && /* @__PURE__ */ jsxs14("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx16(Typography14, { as: "h2", variant: "heading-L", children: section == null ? void 0 : section.title }),
          (section == null ? void 0 : section.subtitle) && /* @__PURE__ */ jsx16(Typography14, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx16("div", { className: "space-y-M md:space-y-L", children: groupedEvents == null ? void 0 : groupedEvents.map((group) => /* @__PURE__ */ jsxs14("div", { className: "w-full", children: [
          /* @__PURE__ */ jsx16(Typography14, { variant: "heading-XS", className: "mb-4 mt-8 hidden md:block", children: group.displayDate }),
          /* @__PURE__ */ jsx16("div", { className: "space-y-M", children: group.events.map((event, index) => {
            var _a, _b, _c, _d;
            const resolvedType = resolveContentfulEventType(event);
            const startDate = (_b = (_a = event.schedule) == null ? void 0 : _a.openDateTime) != null ? _b : null;
            const notifyMe = !!((_c = event.eventType) == null ? void 0 : _c.includes("offline"));
            return /* @__PURE__ */ jsxs14(
              Button10,
              {
                as: Link9,
                to: `/${locale}/${resolvedType}/${event.slug}`,
                className: "gap-M py-S border-paper w-full items-end focus:ring-1 md:items-center",
                shape: "outlined",
                theme: "action",
                onClick: () => {
                  var _a2;
                  trackEvent({
                    event: "clicked_on_section_item",
                    data: {
                      type: event.__typename,
                      item_id: (_a2 = event.sys) == null ? void 0 : _a2.id,
                      slug: event.slug,
                      section: section.id,
                      position: index
                    }
                  });
                },
                children: [
                  /* @__PURE__ */ jsxs14("div", { className: "gap-M flex w-full flex-col-reverse items-start md:flex-row md:items-center", children: [
                    event.image32 && /* @__PURE__ */ jsx16(ContentfulMedia_default, { media: event.image32, className: "max-h-10 w-auto" }),
                    /* @__PURE__ */ jsxs14("div", { className: "space-y-XXS text-start", children: [
                      /* @__PURE__ */ jsx16(
                        Typography14,
                        {
                          variant: "body-S",
                          color: "text-secondary",
                          className: "hidden md:block",
                          children: event.subtitle
                        }
                      ),
                      /* @__PURE__ */ jsx16(Typography14, { variant: "label-L", className: "hidden md:block", children: event.title }),
                      /* @__PURE__ */ jsxs14("div", { className: "gap-x-XS gap-y-XXS flex flex-col items-start md:flex-row md:items-center", children: [
                        startDate && /* @__PURE__ */ jsxs14("div", { className: "gap-XXS hidden items-center md:flex", children: [
                          /* @__PURE__ */ jsx16(ClockIcon3, { className: "text-text-secondary h-5 w-5 object-contain" }),
                          /* @__PURE__ */ jsx16(Typography14, { variant: "body-S", color: "text-secondary", children: formatDate4(startDate, locale, { timeStyle: "short" }) })
                        ] }),
                        startDate && /* @__PURE__ */ jsx16(Typography14, { variant: "label-S", className: "md:hidden", children: formatDate4(startDate, locale, {
                          timeStyle: "short",
                          dateStyle: "long"
                        }) }),
                        /* @__PURE__ */ jsxs14("div", { className: "gap-XXS flex w-full items-start justify-start md:w-auto md:items-center", children: [
                          /* @__PURE__ */ jsx16(LocationIcon3, { className: "text-text-secondary hidden h-4 w-4 object-contain md:block" }),
                          /* @__PURE__ */ jsx16(Typography14, { variant: "body-S", color: "text-secondary", children: (_d = event == null ? void 0 : event.location) == null ? void 0 : _d.title })
                        ] })
                      ] })
                    ] })
                  ] }),
                  notifyMe ? /* @__PURE__ */ jsxs14("div", { className: "gap-S md:gap-M flex w-auto flex-col items-center md:flex-row", children: [
                    /* @__PURE__ */ jsx16(
                      Typography14,
                      {
                        variant: "body-S",
                        color: "text-secondary",
                        className: "whitespace-nowrap",
                        children: t("contentful_common:tickets_not_available")
                      }
                    ),
                    /* @__PURE__ */ jsx16(
                      NotifyButton_default,
                      {
                        event,
                        className: "py-S min-h-0 whitespace-nowrap",
                        theme: "action",
                        textVariant: "body-M"
                      }
                    )
                  ] }) : /* @__PURE__ */ jsxs14("div", { className: "gap-M flex shrink-0 flex-col items-center md:flex-row", children: [
                    /* @__PURE__ */ jsxs14(
                      "div",
                      {
                        "data-resell": event.showResellBanner,
                        className: "flex items-end gap-1.5 data-[resell=true]:hidden md:data-[resell=true]:flex",
                        children: [
                          /* @__PURE__ */ jsx16(Typography14, { variant: "body-S", color: "text-secondary", children: t("contentful_common:starts_from") }),
                          /* @__PURE__ */ jsx16(
                            CurrencyPriceLabel5,
                            {
                              originalPrice: event.startingPrice || 0,
                              currency: event.currencyCode
                            }
                          )
                        ]
                      }
                    ),
                    event.showResellBanner && /* @__PURE__ */ jsxs14("div", { className: "space-y-S md:space-y-0", children: [
                      /* @__PURE__ */ jsx16(Typography14, { variant: "body-S", color: "error", className: "md:hidden", children: t("contentful_event:sold_out") }),
                      /* @__PURE__ */ jsx16("object", { children: /* @__PURE__ */ jsx16(
                        Button_default,
                        {
                          className: "whitespace-nowrap",
                          theme: "action",
                          shape: "outlined",
                          slug: event.slug,
                          title: /* @__PURE__ */ jsx16(Typography14, { children: t("contentful_event:resell.check_resale") })
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ jsx16(
                      Button10,
                      {
                        "data-resell": event.showResellBanner,
                        className: "w-full max-w-xl whitespace-nowrap font-bold data-[resell=true]:hidden md:max-w-fit md:data-[resell=true]:block",
                        children: t("contentful_common:book_now")
                      }
                    )
                  ] })
                ]
              },
              event.slug
            );
          }) })
        ] }, group.dayKey)) })
      ]
    }
  );
};
var ListItemDateGrouped_default = ProductListItemsDateGrouped;

// src/components/product/sections/NumberedCarousel.tsx
import { Carousel as Carousel9, Typography as Typography15 } from "@wbk/ui";
import { jsx as jsx17, jsxs as jsxs15 } from "react/jsx-runtime";
var ProductsNumberedCarousel = ({ section }) => {
  const events = section.contentCollection.items;
  if (!(events == null ? void 0 : events.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs15(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_events_numbered_carousel_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsx17(Typography15, { as: "h2", variant: "heading-L", children: section.title }),
        section.subtitle && /* @__PURE__ */ jsx17(Typography15, { color: "text-secondary", className: "mt-1", children: section.subtitle }),
        /* @__PURE__ */ jsx17(Carousel9, { options: { dragFree: true }, className: "py-0.5", arrows: "middle", children: events.map((event, i) => /* @__PURE__ */ jsxs15(
          "div",
          {
            className: "relative mr-1 flex shrink-0 basis-full sm:basis-3/4 md:basis-3/5 lg:basis-1/2 xl:basis-2/5",
            children: [
              /* @__PURE__ */ jsx17("div", { className: "text-text-secondary hidden self-end pb-12 text-[300px] font-semibold sm:block ltr:-mr-8 rtl:-ml-8", children: i + 1 }),
              /* @__PURE__ */ jsx17(
                Item_default,
                {
                  item: event,
                  cardType: section.itemRenderType,
                  section,
                  index: i
                }
              )
            ]
          },
          i
        )) })
      ]
    }
  );
};
var NumberedCarousel_default = ProductsNumberedCarousel;

// src/components/product/sections/organization/ListItemOrganization.tsx
import { useMemo as useMemo6, useState as useState5 } from "react";
import { useEventsList } from "@wbk/api/hooks";
import { useRouter as useRouter15, useTranslation as useTranslation10 } from "@wbk/config";
import { Button as Button12, Carousel as Carousel10, ResponsiveMenu, Typography as Typography17 } from "@wbk/ui";
import { ChevronIcon as ChevronIcon4 } from "@wbk/svg";

// src/components/product/sections/organization/MatchItem.tsx
import { twMerge as twMerge5 } from "tailwind-merge";
import { Button as Button11, ImageWithPlaceholder as ImageWithPlaceholder2, Typography as Typography16 } from "@wbk/ui";
import { ClockIcon as ClockIcon4, LocationIcon as LocationIcon4 } from "@wbk/svg";
import { CurrencyPriceLabel as CurrencyPriceLabel6 } from "@wbk/currency";
import { formatDate as formatDate5 } from "@wbk/utils";
import { Link as Link10, useRouter as useRouter14, useTranslation as useTranslation9 } from "@wbk/config";
import { useAnalytics as useAnalytics9 } from "@wbk/analytics";
import { Fragment as Fragment11, jsx as jsx18, jsxs as jsxs16 } from "react/jsx-runtime";
var Match = ({ event, className, index }) => {
  var _a, _b;
  const { t } = useTranslation9(["contentful_common", "contentful_event"]);
  const { locale } = useRouter14();
  const home = event.home_team;
  const away = event.away_team;
  const isScore = !!(home == null ? void 0 : home.score) && !!(away == null ? void 0 : away.score);
  const startDate = (_a = event.start_date_time) != null ? _a : null;
  const { trackEvent } = useAnalytics9();
  return /* @__PURE__ */ jsxs16(
    Button11,
    {
      as: Link10,
      to: `/${locale}/events/${event.slug}`,
      className: twMerge5(
        "gap-M py-S border-paper w-full items-end focus:ring-1 md:items-center",
        className
      ),
      shape: "outlined",
      theme: "action",
      onClick: () => {
        trackEvent({
          event: "clicked_on_section_item",
          data: {
            type: event.type,
            slug: event.slug,
            position: index
          }
        });
      },
      children: [
        /* @__PURE__ */ jsxs16("div", { className: "gap-M flex w-full flex-col-reverse items-start md:flex-row md:items-center", children: [
          /* @__PURE__ */ jsxs16("div", { className: "gap-S flex shrink-0 flex-col items-center md:flex-row", children: [
            /* @__PURE__ */ jsxs16("div", { className: "flex w-full items-center gap-2", children: [
              /* @__PURE__ */ jsx18(ImageWithPlaceholder2, { src: home == null ? void 0 : home.logo, className: "h-8 w-8 rounded-full object-cover" }),
              /* @__PURE__ */ jsx18(Typography16, { className: "md:hidden", children: home == null ? void 0 : home.name })
            ] }),
            /* @__PURE__ */ jsx18(Typography16, { className: "hidden md:block", children: t("contentful_event:vs") }),
            /* @__PURE__ */ jsxs16("div", { className: "flex w-full items-center gap-2", children: [
              /* @__PURE__ */ jsx18(ImageWithPlaceholder2, { src: away == null ? void 0 : away.logo, className: "h-8 w-8 rounded-full object-cover" }),
              /* @__PURE__ */ jsx18(Typography16, { className: "md:hidden", children: away == null ? void 0 : away.name })
            ] })
          ] }),
          /* @__PURE__ */ jsxs16("div", { className: "space-y-XXS text-start", children: [
            /* @__PURE__ */ jsx18(
              Typography16,
              {
                variant: "body-S",
                color: "text-secondary",
                className: "hidden md:block"
              }
            ),
            /* @__PURE__ */ jsx18(Typography16, { variant: "label-L", className: "hidden md:block", children: event.title }),
            /* @__PURE__ */ jsxs16("div", { className: "gap-x-XS gap-y-XXS flex flex-col items-start md:flex-row md:items-center", children: [
              startDate && /* @__PURE__ */ jsxs16("div", { className: "gap-XXS hidden items-center md:flex", children: [
                /* @__PURE__ */ jsx18(ClockIcon4, { className: "text-text-secondary h-5 w-5 object-contain" }),
                /* @__PURE__ */ jsx18(Typography16, { variant: "body-S", color: "text-secondary", children: formatDate5(startDate, locale, { timeStyle: "short" }) })
              ] }),
              startDate && /* @__PURE__ */ jsx18(Typography16, { variant: "label-S", className: "md:hidden", children: formatDate5(startDate, locale, {
                timeStyle: "short",
                dateStyle: "long"
              }) }),
              /* @__PURE__ */ jsxs16("div", { className: "gap-XXS flex w-full items-start justify-start md:w-auto md:items-center", children: [
                /* @__PURE__ */ jsx18(LocationIcon4, { className: "text-text-secondary hidden h-4 w-4 object-contain md:block" }),
                /* @__PURE__ */ jsx18(Typography16, { variant: "body-S", color: "text-secondary", children: (_b = event == null ? void 0 : event.venue) == null ? void 0 : _b.name })
              ] })
            ] })
          ] })
        ] }),
        !isScore ? /* @__PURE__ */ jsx18(Fragment11, { children: event.is_notify_me_enabled ? /* @__PURE__ */ jsxs16("div", { className: "gap-S md:gap-M flex w-auto flex-col items-center md:flex-row", children: [
          /* @__PURE__ */ jsx18(Typography16, { variant: "body-S", color: "text-secondary", className: "whitespace-nowrap", children: t("contentful_common:tickets_not_available") }),
          /* @__PURE__ */ jsx18(
            NotifyButton_default,
            {
              event: {
                __typename: "event",
                id: event._id,
                title: event.title,
                slug: event.slug
              },
              className: "py-S min-h-0 whitespace-nowrap",
              theme: "action",
              textVariant: "body-M"
            }
          )
        ] }) : /* @__PURE__ */ jsxs16("div", { className: "gap-M flex shrink-0 flex-col items-center md:flex-row", children: [
          /* @__PURE__ */ jsxs16(
            "div",
            {
              "data-resell": event.resale_status,
              className: "flex items-end gap-1.5 data-[resell=true]:hidden md:data-[resell=true]:flex",
              children: [
                /* @__PURE__ */ jsx18(Typography16, { variant: "body-S", color: "text-secondary", children: t("contentful_common:starts_from") }),
                /* @__PURE__ */ jsx18(
                  CurrencyPriceLabel6,
                  {
                    originalPrice: event.event_start_price + event.event_start_vat,
                    currency: event.currency
                  }
                )
              ]
            }
          ),
          event.resale_status && /* @__PURE__ */ jsxs16("div", { className: "space-y-XS md:space-y-0", children: [
            /* @__PURE__ */ jsx18(Typography16, { variant: "body-S", color: "error", className: "md:hidden", children: t("contentful_event:sold_out") }),
            /* @__PURE__ */ jsx18("object", { children: /* @__PURE__ */ jsx18(
              Button_default,
              {
                theme: "action",
                shape: "outlined",
                slug: event.slug,
                className: "whitespace-nowrap",
                title: /* @__PURE__ */ jsx18(Typography16, { children: t("contentful_event:resell.check_resale") })
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx18(
            Button11,
            {
              "data-resell": event.resale_status,
              className: "w-full max-w-xl whitespace-nowrap font-bold data-[resell=true]:hidden md:max-w-fit md:data-[resell=true]:block",
              children: t("contentful_common:book_now")
            }
          )
        ] }) }) : /* @__PURE__ */ jsxs16(Fragment11, { children: [
          /* @__PURE__ */ jsx18(Typography16, { variant: "label-L", className: "hidden whitespace-nowrap md:block", children: t("contentful_event:score", { home: home == null ? void 0 : home.score, away: away == null ? void 0 : away.score }) }),
          /* @__PURE__ */ jsxs16("div", { className: "space-y-S md:hidden", children: [
            /* @__PURE__ */ jsx18(Typography16, { variant: "label-L", children: home == null ? void 0 : home.score }),
            /* @__PURE__ */ jsx18(Typography16, { variant: "label-L", children: away == null ? void 0 : away.score })
          ] })
        ] })
      ]
    },
    event.slug
  );
};
var MatchItem_default = Match;

// src/components/product/sections/organization/ListItemOrganization.tsx
import { jsx as jsx19, jsxs as jsxs17 } from "react/jsx-runtime";
var ProductListItemsOrganization = ({ section }) => {
  const { locale } = useRouter15();
  const { t } = useTranslation10(["contentful_common", "contentful_event"]);
  const [selectedTeam, setSelectedTeam] = useState5("");
  const [selectedStadium, setSelectedStadium] = useState5("");
  const organizationSlug = section.organizationSlug;
  const { data, isLoading } = useEventsList({
    organizationSlug: organizationSlug || "",
    lang: locale,
    publicOnly: true
  });
  const { teams, venues } = useMemo6(() => {
    var _a;
    const teamMap = /* @__PURE__ */ new Map();
    const venueMap = /* @__PURE__ */ new Map();
    (_a = data == null ? void 0 : data.events) == null ? void 0 : _a.forEach((event) => {
      var _a2, _b, _c;
      if ((_a2 = event.venue) == null ? void 0 : _a2._id) {
        venueMap.set(event.venue._id, {
          _id: event.venue._id,
          name: event.venue.name
        });
      }
      if ((_b = event.home_team) == null ? void 0 : _b._id) {
        teamMap.set(event.home_team._id, {
          _id: event.home_team._id,
          name: event.home_team.name,
          logo: event.home_team.logo
        });
      }
      if ((_c = event.away_team) == null ? void 0 : _c._id) {
        teamMap.set(event.away_team._id, {
          _id: event.away_team._id,
          name: event.away_team.name,
          logo: event.away_team.logo
        });
      }
    });
    return {
      teams: Array.from(teamMap.values()),
      venues: Array.from(venueMap.values())
    };
  }, [data == null ? void 0 : data.events]);
  const resetFilters = () => {
    setSelectedTeam("");
    setSelectedStadium("");
  };
  const filtersArray = useMemo6(() => {
    const filters3 = [];
    if (Number(data == null ? void 0 : data.events.length) < 2) {
      return [];
    }
    const initialFilterOption = {
      label: t("contentful_event:all"),
      value: "",
      text: t("contentful_event:all")
    };
    const teamsOptions = teams.length ? [
      initialFilterOption,
      ...teams.map((team) => ({
        label: team.name,
        value: team._id,
        text: /* @__PURE__ */ jsx19(Typography17, { variant: "label-M", className: "max-w-48 break-words", children: team.name })
      }))
    ] : [];
    const stadiumsOptions = venues.length ? [
      initialFilterOption,
      ...venues.map((venue) => ({
        label: venue.name,
        value: venue._id,
        text: /* @__PURE__ */ jsx19(Typography17, { variant: "label-M", className: "max-w-48 break-words", children: venue.name })
      }))
    ] : [];
    if (teamsOptions == null ? void 0 : teamsOptions.length) {
      filters3.push({
        id: "teams",
        placeholder: t("contentful_event:all_teams"),
        value: selectedTeam || "",
        options: teamsOptions,
        onChange: setSelectedTeam || (() => {
        })
      });
    }
    if (stadiumsOptions == null ? void 0 : stadiumsOptions.length) {
      filters3.push({
        id: "stadiums",
        placeholder: t("contentful_event:all_stadiums"),
        value: selectedStadium || "",
        options: stadiumsOptions,
        onChange: setSelectedStadium || (() => {
        })
      });
    }
    return filters3;
  }, [t, teams, venues, selectedTeam, selectedStadium, data == null ? void 0 : data.events]);
  const filteredEvents = useMemo6(() => {
    var _a, _b;
    return (_b = (_a = data == null ? void 0 : data.events) == null ? void 0 : _a.filter((event) => {
      var _a2, _b2, _c;
      const byStadium = selectedStadium ? ((_a2 = event.venue) == null ? void 0 : _a2._id) === selectedStadium : true;
      const byTeam = selectedTeam ? ((_b2 = event.home_team) == null ? void 0 : _b2._id) === selectedTeam || ((_c = event.away_team) == null ? void 0 : _c._id) === selectedTeam : true;
      return byStadium && byTeam;
    })) != null ? _b : [];
  }, [data == null ? void 0 : data.events, selectedTeam, selectedStadium]);
  const groupedEvents = useMemo6(
    () => groupEventsByDay(filteredEvents, locale),
    [filteredEvents, locale]
  );
  return /* @__PURE__ */ jsxs17(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_events_list_item_organization${section.id}`,
      children: [
        /* @__PURE__ */ jsxs17("div", { className: "gap-L flex w-full flex-wrap items-center justify-between", children: [
          (section == null ? void 0 : section.title) && /* @__PURE__ */ jsxs17("div", { className: "space-y-1", children: [
            /* @__PURE__ */ jsx19(Typography17, { as: "h2", variant: "heading-L", children: section == null ? void 0 : section.title }),
            (section == null ? void 0 : section.subtitle) && /* @__PURE__ */ jsx19(Typography17, { color: "text-secondary", children: section.subtitle })
          ] }),
          /* @__PURE__ */ jsx19(Carousel10, { children: filtersArray.map((filter) => {
            var _a;
            return /* @__PURE__ */ jsx19(
              ResponsiveMenu,
              {
                className: "shrink-0 ltr:mr-4 rtl:ml-4",
                render: ({ open }) => {
                  var _a2;
                  return /* @__PURE__ */ jsxs17(
                    Button12,
                    {
                      theme: "action",
                      shape: "outlined",
                      className: "border-paper-level-2",
                      onClick: () => {
                        open();
                      },
                      children: [
                        /* @__PURE__ */ jsx19(Typography17, { variant: "label-S", children: ((_a2 = filter.options.find(
                          (option) => option.value === filter.value && option.value !== ""
                        )) == null ? void 0 : _a2.text) || filter.placeholder }),
                        /* @__PURE__ */ jsx19(ChevronIcon4, { className: "mx-1 inline h-3 w-3 rotate-90" })
                      ]
                    }
                  );
                },
                options: (_a = filter.options) != null ? _a : [],
                value: filter.value || "",
                onChange: (value) => filter.onChange(value.value),
                hideErrorSpace: true,
                sheet: {
                  ignoreHistory: true
                }
              },
              filter.id
            );
          }) })
        ] }),
        /* @__PURE__ */ jsx19("div", { className: "space-y-L", children: isLoading ? /* @__PURE__ */ jsx19(MatchItemLoader_default, { className: "space-y-M h-40 shrink-0 md:h-20" }) : !groupedEvents.length ? /* @__PURE__ */ jsxs17("div", { className: "flex w-full flex-col items-center justify-center gap-4 py-12", children: [
          /* @__PURE__ */ jsx19(Typography17, { variant: "label-M", children: t("contentful_event:no_events") }),
          /* @__PURE__ */ jsx19(Button12, { onClick: resetFilters, children: t("contentful_event:reset_filters") })
        ] }) : groupedEvents.map((group) => /* @__PURE__ */ jsxs17("div", { className: "space-y-M", children: [
          /* @__PURE__ */ jsx19(Typography17, { variant: "heading-XS", children: group.displayDate }),
          /* @__PURE__ */ jsx19("div", { className: "space-y-M", children: group.events.map((event) => /* @__PURE__ */ jsx19(MatchItem_default, { event }, event._id)) })
        ] }, group.dayKey)) })
      ]
    }
  );
};
var ListItemOrganization_default = ProductListItemsOrganization;

// src/components/product/sections/organization/ListItemDateCategorizedOrganization.tsx
import { useState as useState6 } from "react";
import { useGetTeamEvents } from "@wbk/api/hooks";
import { useRouter as useRouter16, useTranslation as useTranslation11 } from "@wbk/config";
import { Button as Button13, Typography as Typography18 } from "@wbk/ui";
import { formatDate as formatDate6 } from "@wbk/utils";
import { jsx as jsx20, jsxs as jsxs18 } from "react/jsx-runtime";
var filters2 = ["all", "upcoming", "past"];
var ProductListItemsDateCategorizedOrganization = ({ section }) => {
  const { locale } = useRouter16();
  const { t } = useTranslation11(["contentful_common", "contentful_event"]);
  const [filter, setFilter] = useState6("upcoming");
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useGetTeamEvents({
    organizationSlug: section.organizationSlug || "",
    teamId: section.teamId || "",
    lang: locale,
    status: filter
  });
  return /* @__PURE__ */ jsxs18(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_events_list_item_date_grouped_${section.id}`,
      children: [
        (section == null ? void 0 : section.title) && /* @__PURE__ */ jsxs18("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx20(Typography18, { as: "h2", variant: "heading-L", children: section == null ? void 0 : section.title }),
          (section == null ? void 0 : section.subtitle) && /* @__PURE__ */ jsx20(Typography18, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx20("div", { className: "gap-S mt-M flex", children: filters2.map((f) => /* @__PURE__ */ jsx20(
          Button13,
          {
            shape: "outlined",
            theme: "white",
            onClick: () => setFilter(f),
            "data-active": filter === f,
            className: "border-paper-level-1 text-paper-level-3 data-[active=true]:border-action data-[active=true]:text-action",
            children: /* @__PURE__ */ jsx20(Typography18, { variant: "label-M", children: t(`contentful_common:filters.${f}`) })
          },
          f
        )) }),
        /* @__PURE__ */ jsx20("div", { className: "space-y-L", children: isLoading ? /* @__PURE__ */ jsx20(MatchItemLoader_default, { className: "space-y-M h-40 shrink-0 md:h-20" }) : !(data == null ? void 0 : data.data.length) ? /* @__PURE__ */ jsx20("div", { className: "flex w-full flex-col items-center justify-center gap-4 py-12", children: /* @__PURE__ */ jsx20(Typography18, { variant: "label-M", children: t("contentful_event:no_events") }) }) : /* @__PURE__ */ jsxs18("div", { className: "space-y-L", children: [
          data == null ? void 0 : data.data.map((event) => /* @__PURE__ */ jsxs18("div", { className: "space-y-M", children: [
            /* @__PURE__ */ jsx20(Typography18, { variant: "heading-XS", children: formatDate6(event.start_date_time, `${locale}-GB`, {
              weekday: "short",
              day: "numeric",
              month: "long",
              year: "numeric"
            }) }),
            /* @__PURE__ */ jsx20(MatchItem_default, { event }, event._id)
          ] }, event._id)),
          hasNextPage && /* @__PURE__ */ jsx20("div", { className: "py-5 text-center", children: /* @__PURE__ */ jsx20(
            Button13,
            {
              theme: "action",
              shape: "outlined",
              className: "w-full max-w-[200px]",
              loading: isFetchingNextPage,
              disabled: !hasNextPage,
              onClick: () => fetchNextPage(),
              children: t("contentful_common:load_more")
            }
          ) })
        ] }) })
      ]
    }
  );
};
var ListItemDateCategorizedOrganization_default = ProductListItemsDateCategorizedOrganization;

// src/components/product/sections/organization/TicketsOrganization.tsx
import { useMemo as useMemo7, useState as useState7 } from "react";
import { useEventsList as useEventsList2, useGetTickets } from "@wbk/api/hooks";
import { Link as Link11, useRouter as useRouter17, useTranslation as useTranslation12 } from "@wbk/config";
import { CurrencyPriceLabel as CurrencyPriceLabel7 } from "@wbk/currency";
import { twMerge as twMerge6 } from "tailwind-merge";
import { ExclamationIcon, WbkTicketIcon } from "@wbk/svg";
import {
  Button as Button14,
  Carousel as Carousel11,
  Divider,
  ImageWithPlaceholder as ImageWithPlaceholder3,
  Paper as Paper2,
  ResponsiveModal,
  Typography as Typography19
} from "@wbk/ui";
import { formatDate as formatDate7 } from "@wbk/utils";
import { AccessibilityButton } from "@wbk/ticketing";
import { Fragment as Fragment12, jsx as jsx21, jsxs as jsxs19 } from "react/jsx-runtime";
var ProductTicketsOrganization = ({ section }) => {
  var _a, _b, _c, _d;
  const { locale } = useRouter17();
  const { t } = useTranslation12(["contentful_common", "contentful_event"]);
  const [selectedItemIndex, setSelectedItemIndex] = useState7(0);
  const [selectedTicketIndex, setSelectedTicketIndex] = useState7(0);
  const cardImage = (_b = (_a = section == null ? void 0 : section.contentCollection) == null ? void 0 : _a.items[0]) == null ? void 0 : _b.image;
  const organizationSlug = section.organizationSlug;
  const { data, isLoading, error } = useEventsList2(
    {
      organizationSlug: organizationSlug || "",
      lang: locale,
      publicOnly: true
    },
    { enabled: !!organizationSlug }
  );
  const events = data == null ? void 0 : data.events;
  const seasons = data == null ? void 0 : data.seasons;
  const items = useMemo7(
    () => [
      ...(seasons || []).map((season) => __spreadProps(__spreadValues({}, season), { ticketType: "season" })),
      ...(events || []).map((event) => __spreadProps(__spreadValues({}, event), { ticketType: "event" }))
    ],
    [events, seasons]
  );
  const selectedItem = items[selectedItemIndex];
  const {
    data: ticketData,
    isLoading: isTicketsLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage
  } = useGetTickets(
    {
      lang: locale,
      slug: (selectedItem == null ? void 0 : selectedItem.slug) || "",
      ticketType: (selectedItem == null ? void 0 : selectedItem.ticketType) || "event",
      perPage: 5
    },
    { enabled: !!(selectedItem == null ? void 0 : selectedItem.slug) }
  );
  const tickets = (ticketData == null ? void 0 : ticketData.tickets) || [];
  const optionsCount = ((_c = ticketData == null ? void 0 : ticketData.meta) == null ? void 0 : _c.total) || tickets.length;
  const safeSelectedTicketIndex = tickets.length ? Math.min(selectedTicketIndex, tickets.length - 1) : 0;
  const selectedTicket = tickets[safeSelectedTicketIndex];
  const bookingPath = selectedItem ? `/${locale}/${selectedItem.ticketType === "season" ? "seasons" : "events"}/${selectedItem.slug}/book` : "";
  if (!organizationSlug || error) return null;
  return /* @__PURE__ */ jsx21(
    DecoratedSection_default,
    {
      section,
      "data-testid": `section_event_tickets_organization_${section.id}`,
      children: /* @__PURE__ */ jsxs19("div", { className: "container space-y-6", children: [
        section.title && /* @__PURE__ */ jsxs19("div", { className: "space-y-1 text-center", children: [
          /* @__PURE__ */ jsx21(Typography19, { as: "h2", variant: "heading-XXL", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx21(Typography19, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx21(Paper2, { surface: "level-1", border: false, className: "space-y-L md:p-6", children: isLoading ? /* @__PURE__ */ jsxs19("div", { className: "space-y-4", children: [
          /* @__PURE__ */ jsx21("div", { className: "bg-paper-level-2 h-10 w-full animate-pulse rounded-xl" }),
          /* @__PURE__ */ jsx21("div", { className: "bg-paper-level-2 h-56 w-full animate-pulse rounded-xl" })
        ] }) : !items.length ? /* @__PURE__ */ jsx21(Typography19, { variant: "label-M", className: "py-8 text-center", children: t("contentful_event:no_events") }) : /* @__PURE__ */ jsxs19(Fragment12, { children: [
          /* @__PURE__ */ jsx21(Carousel11, { options: { dragFree: true }, children: items.map((item, index) => {
            const isSelected = index === selectedItemIndex;
            const startDate = item.start_date_time ? formatDate7(item.start_date_time, `${locale}-GB`, {
              day: "numeric",
              month: "short"
            }) : "";
            const endDate = item.end_date_time ? formatDate7(item.end_date_time, `${locale}-GB`, {
              day: "numeric",
              month: "short"
            }) : "";
            const date = startDate && endDate ? startDate === endDate ? startDate : `${startDate} - ${endDate}` : startDate;
            return /* @__PURE__ */ jsxs19(
              Button14,
              {
                theme: isSelected ? "primary" : "action",
                shape: isSelected ? "solid" : "text",
                onClick: () => {
                  setSelectedItemIndex(index);
                  setSelectedTicketIndex(0);
                },
                className: twMerge6(
                  "!py-S me-1 flex-1 shrink-0 flex-col justify-between",
                  items.length > 2 ? "basis-[40%]" : "basis-[calc(50%-0.5rem)]",
                  !isSelected && "bg-body-level-2"
                ),
                children: [
                  /* @__PURE__ */ jsxs19("div", { className: "space-y-XXS", children: [
                    /* @__PURE__ */ jsx21(
                      Typography19,
                      {
                        variant: "heading-XXS",
                        className: "line-clamp-2 text-inherit",
                        as: "h3",
                        children: item.title
                      }
                    ),
                    /* @__PURE__ */ jsx21(
                      Typography19,
                      {
                        variant: "label-XS",
                        className: "line-clamp-1 leading-tight text-inherit",
                        as: "h4",
                        children: item.sub_title
                      }
                    )
                  ] }),
                  date && /* @__PURE__ */ jsx21(
                    Typography19,
                    {
                      variant: "body-S",
                      color: "text-secondary",
                      className: "data-[active=true]:text-inherit",
                      "data-active": isSelected,
                      children: date
                    }
                  )
                ]
              },
              `${item.ticketType}-${item._id}`
            );
          }) }),
          /* @__PURE__ */ jsxs19("div", { className: "gap-L flex flex-col md:flex-row-reverse", children: [
            /* @__PURE__ */ jsx21("div", { className: "sticky top-12 z-10 w-full md:top-20 md:basis-1/2 md:self-start xl:basis-2/3", children: /* @__PURE__ */ jsx21(
              ImageWithPlaceholder3,
              {
                src: ((_d = selectedTicket == null ? void 0 : selectedTicket.gallery_images) == null ? void 0 : _d[0]) || (cardImage == null ? void 0 : cardImage.url) || "",
                alt: (selectedTicket == null ? void 0 : selectedTicket.title) || (selectedItem == null ? void 0 : selectedItem.title) || section.title || "",
                className: "border-body-level-4 shadow-body-level-1 aspect-[3/2] w-full rounded-2xl border object-cover shadow-2xl md:border-none md:shadow-none",
                ratio: "3x1"
              }
            ) }),
            /* @__PURE__ */ jsx21("div", { className: "w-full shrink-0 space-y-4 md:flex-1", children: isTicketsLoading ? /* @__PURE__ */ jsx21("div", { className: "space-y-M", children: [1, 2, 3].map((item) => /* @__PURE__ */ jsx21("div", { className: "bg-paper-level-2 rounded-S h-32 animate-pulse" }, item)) }) : tickets.length ? /* @__PURE__ */ jsxs19(Fragment12, { children: [
              /* @__PURE__ */ jsx21(Typography19, { variant: "heading-S", as: "h3", children: t("contentful_event:options_available", { count: optionsCount }) }),
              /* @__PURE__ */ jsx21("div", { className: "space-y-M hide-scrollbar overflow-y-auto pe-1", children: tickets.map((ticket, index) => {
                var _a2, _b2, _c2, _d2;
                const fee = (Number((_b2 = (_a2 = ticketData == null ? void 0 : ticketData.event) == null ? void 0 : _a2.fees) == null ? void 0 : _b2.amount) || 0) + (Number((_d2 = (_c2 = ticketData == null ? void 0 : ticketData.event) == null ? void 0 : _c2.fees) == null ? void 0 : _d2.vat) || 0);
                const query3 = new URLSearchParams(__spreadValues(__spreadValues({}, ticket._id && { ticket_id: ticket._id }), ticket.seats_io_category && {
                  seats_io_category: ticket.seats_io_category
                })).toString();
                const hrefParams = query3 ? `${bookingPath}?${query3}` : bookingPath;
                return /* @__PURE__ */ jsxs19(
                  Paper2,
                  {
                    surface: "level-2",
                    className: "data-[active=true]:border-primary border-2 border-transparent !p-0 transition-colors",
                    tabIndex: 0,
                    onMouseEnter: () => setSelectedTicketIndex(index),
                    onFocus: () => setSelectedTicketIndex(index),
                    "data-active": index === safeSelectedTicketIndex,
                    children: [
                      /* @__PURE__ */ jsxs19("div", { className: "border-paper-level-2 flex items-center justify-between border-b p-4", children: [
                        /* @__PURE__ */ jsxs19("div", { className: "flex min-w-0 items-center gap-3", children: [
                          /* @__PURE__ */ jsxs19(
                            "div",
                            {
                              className: "relative",
                              "data-testid": `ticket-type-badge-${ticket._id}`,
                              children: [
                                /* @__PURE__ */ jsx21(
                                  WbkTicketIcon,
                                  {
                                    style: {
                                      color: ticket.ticket_color
                                    }
                                  }
                                ),
                                /* @__PURE__ */ jsx21(
                                  "span",
                                  {
                                    className: "text-body-contrast absolute inset-0 flex items-center justify-center text-xs",
                                    style: {
                                      color: ticket.text_color
                                    },
                                    children: ticket.shortcode || ticket.title.slice(0, 2).toUpperCase()
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ jsx21(Typography19, { variant: "label-M", as: "h4", className: "line-clamp-3", children: ticket.title })
                        ] }),
                        !!ticket.description && /* @__PURE__ */ jsx21(
                          ResponsiveModal,
                          {
                            size: "2xl",
                            action: ticket.accessible ? false : {
                              label: t("contentful_event:select_seats"),
                              as: Link11,
                              to: bookingPath,
                              className: "w-full"
                            },
                            title: ticket.title,
                            cancel: false,
                            render: ({ open }) => /* @__PURE__ */ jsx21(
                              Button14,
                              {
                                theme: "transparent",
                                shape: "text",
                                className: "ms-S shrink-0 p-0",
                                onClick: open,
                                children: /* @__PURE__ */ jsx21(ExclamationIcon, { className: "text-text-secondary h-5 w-5" })
                              }
                            ),
                            body: () => {
                              var _a3;
                              return /* @__PURE__ */ jsxs19("div", { className: "space-y-6", children: [
                                !!((_a3 = ticket.gallery_images) == null ? void 0 : _a3[0]) && /* @__PURE__ */ jsx21(
                                  ImageWithPlaceholder3,
                                  {
                                    src: ticket.gallery_images[0],
                                    alt: ticket.title,
                                    className: "aspect-[16/9] w-full rounded-lg object-cover"
                                  }
                                ),
                                /* @__PURE__ */ jsxs19("div", { className: "space-y-3", children: [
                                  /* @__PURE__ */ jsx21(Typography19, { variant: "label-L", color: "text-secondary", children: t("contentful_event:general_info") }),
                                  /* @__PURE__ */ jsx21(Divider, { className: "border-paper-level-2" }),
                                  /* @__PURE__ */ jsx21(
                                    "div",
                                    {
                                      dangerouslySetInnerHTML: {
                                        __html: ticket.description
                                      }
                                    }
                                  )
                                ] })
                              ] });
                            }
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsxs19("div", { className: "flex flex-wrap items-center justify-between gap-x-4 gap-y-3 p-4", children: [
                        /* @__PURE__ */ jsx21(
                          CurrencyPriceLabel7,
                          {
                            originalPrice: Number(ticket.original_price || 0) + Number(ticket.original_price_vat || 0) + fee,
                            discountPrice: Number(ticket.price || 0) + Number(ticket.vat || 0) + fee,
                            currency: ticket.currency,
                            zeroAsFree: true
                          }
                        ),
                        ticket.accessible && selectedItem ? /* @__PURE__ */ jsx21(
                          AccessibilityButton,
                          {
                            slug: selectedItem.slug,
                            type: selectedItem.ticketType === "season" ? "seasons" : "events",
                            render: ({ open, isApproved, isLoading: isLoading2 }) => /* @__PURE__ */ jsx21(
                              Button14,
                              {
                                className: "px-3 py-1.5",
                                onClick: open,
                                shape: "outlined",
                                theme: "action",
                                loading: isLoading2,
                                disabled: isLoading2,
                                "data-testid": `accessibility-cta-${ticket._id}`,
                                children: isApproved ? t("contentful_event:select_seats") : t("contentful_event:verify_accessibility")
                              }
                            )
                          }
                        ) : /* @__PURE__ */ jsx21(
                          Button14,
                          {
                            className: "px-3 py-1.5",
                            as: Link11,
                            to: hrefParams,
                            shape: "outlined",
                            theme: "action",
                            children: t("contentful_event:select_seats")
                          }
                        )
                      ] })
                    ]
                  },
                  ticket._id
                );
              }) }),
              hasNextPage && /* @__PURE__ */ jsx21(
                Button14,
                {
                  theme: "action",
                  shape: "outlined",
                  className: "w-full",
                  onClick: () => fetchNextPage(),
                  loading: isFetchingNextPage,
                  disabled: isFetchingNextPage,
                  children: t("contentful_common:load_more")
                }
              )
            ] }) : /* @__PURE__ */ jsx21(Typography19, { variant: "label-M", className: "py-8 text-center", as: "h4", children: t("contentful_event:no_events") }) })
          ] })
        ] }) })
      ] })
    }
  );
};
var TicketsOrganization_default = ProductTicketsOrganization;

export {
  ActionCardCarousel_default,
  ComingSoonSection_default,
  FullScreenCarousel_default,
  FullScreenGeoCarousel_default,
  GroupTagCarousel_default,
  LongRectangularCarousel_default,
  MasonryCarousel_default,
  MiniListItems_default,
  WhatsNewSection_default,
  GridCarousel_default,
  FocusedCarousel_default,
  GeoSection_default,
  Grid_default,
  ListItem_default,
  ListItemDateCategorized_default,
  ListItemDateGrouped_default,
  NumberedCarousel_default,
  ListItemOrganization_default,
  ListItemDateCategorizedOrganization_default,
  TicketsOrganization_default
};
//# sourceMappingURL=chunk-LWEHHNZX.mjs.map